// 钉钉jsapi
// import * as dd from 'dingtalk-jsapi';
export const isDingtalk = () => {
	let dingtalk = false
	/* if (dd && !dd.other) {
		dingtalk = true
	} */
	return dingtalk
}
export const isWelink = () => {
	let welink = false
	var ua = window.navigator.userAgent;
	if (ua.toLocaleLowerCase().indexOf("welink") > -1 || ua.toLocaleLowerCase().indexOf("huawei") > -1) {
		welink = true
	}
	return welink
}
if (isWelink()) {
	!function (e, t) {
		"object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("hwh5", [], t) : "object" == typeof exports ? exports.hwh5 = t() : e.hwh5 = t()
	}(window, (function () {
		return function (e) {
			var t = {};
			function n(r) {
				if (t[r]) return t[r].exports;
				var a = t[r] = {i: r, l: !1, exports: {}};
				return e[r].call(a.exports, a, a.exports, n), a.l = !0, a.exports
			}
			return n.m = e, n.c = t, n.d = function (e, t, r) {
				n.o(e, t) || Object.defineProperty(e, t, {enumerable: !0, get: r})
			}, n.r = function (e) {
				"undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {value: "Module"}), Object.defineProperty(e, "__esModule", {value: !0})
			}, n.t = function (e, t) {
				if (1 & t && (e = n(e)), 8 & t) return e;
				if (4 & t && "object" == typeof e && e && e.__esModule) return e;
				var r = Object.create(null);
				if (n.r(r), Object.defineProperty(r, "default", {
					enumerable: !0,
					value: e
				}), 2 & t && "string" != typeof e) for (var a in e) n.d(r, a, function (t) {
					return e[t]
				}.bind(null, a));
				return r
			}, n.n = function (e) {
				var t = e && e.__esModule ? function () {
					return e.default
				} : function () {
					return e
				};
				return n.d(t, "a", t), t
			}, n.o = function (e, t) {
				return Object.prototype.hasOwnProperty.call(e, t)
			}, n.p = "", n(n.s = 181)
		}([function (e, t, n) {
			"use strict";
			(function (e) {
				n.d(t, "g", (function () {
					return U
				})), n.d(t, "n", (function () {
					return q
				})), n.d(t, "s", (function () {
					return $
				})), n.d(t, "d", (function () {
					return ee
				})), n.d(t, "e", (function () {
					return G
				})), n.d(t, "x", (function () {
					return ne
				})), n.d(t, "c", (function () {
					return X
				})), n.d(t, "h", (function () {
					return R
				})), n.d(t, "u", (function () {
					return re
				})), n.d(t, "w", (function () {
					return ae
				})), n.d(t, "i", (function () {
					return V
				})), n.d(t, "y", (function () {
					return Y
				})), n.d(t, "B", (function () {
					return oe
				})), n.d(t, "a", (function () {
					return ie
				})), n.d(t, "b", (function () {
					return ce
				})), n.d(t, "r", (function () {
					return ue
				})), n.d(t, "p", (function () {
					return se
				})), n.d(t, "o", (function () {
					return fe
				})), n.d(t, "f", (function () {
					return le
				})), n.d(t, "t", (function () {
					return K
				})), n.d(t, "A", (function () {
					return pe
				})), n.d(t, "j", (function () {
					return de
				})), n.d(t, "m", (function () {
					return he
				})), n.d(t, "q", (function () {
					return me
				})), n.d(t, "k", (function () {
					return ve
				})), n.d(t, "v", (function () {
					return J
				})), n.d(t, "l", (function () {
					return ye
				})), n.d(t, "z", (function () {
					return we
				}));
				var r = n(67), a = n.n(r), o = n(68), i = n.n(o), c = n(41), u = n.n(c), s = n(51), f = n.n(s),
					l = n(70),
					p = n.n(l), d = n(20), h = n.n(d), m = n(8), v = n.n(m), g = n(23), y = n.n(g), b = n(13),
					w = n.n(b),
					x = n(4), k = n.n(x), N = n(1), _ = n.n(N), S = n(3), C = n.n(S), O = n(2), I = n.n(O), j = n(28),
					E = n(71), L = n(16), P = n.n(L), H = n(12), T = n.n(H), A = n(32), F = n(7), B = n(72);
				function W(e, t) {
					var n;
					if (void 0 === u.a || null == e[i.a]) {
						if (w()(e) || (n = function (e, t) {
							if (!e) return;
							if ("string" == typeof e) return D(e, t);
							var n = Object.prototype.toString.call(e).slice(8, -1);
							"Object" === n && e.constructor && (n = e.constructor.name);
							if ("Map" === n || "Set" === n) return f()(e);
							if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return D(e, t)
						}(e)) || t && e && "number" == typeof e.length) {
							n && (e = n);
							var r = 0, o = function () {
							};
							return {
								s: o, n: function () {
									return r >= e.length ? {done: !0} : {done: !1, value: e[r++]}
								}, e: function (e) {
									throw e
								}, f: o
							}
						}
						throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
					}
					var c, s = !0, l = !1;
					return {
						s: function () {
							n = a()(e)
						}, n: function () {
							var e = n.next();
							return s = e.done, e
						}, e: function (e) {
							l = !0, c = e
						}, f: function () {
							try {
								s || null == n.return || n.return()
							} finally {
								if (l) throw c
							}
						}
					}
				}
				function D(e, t) {
					(null == t || t > e.length) && (t = e.length);
					for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
					return r
				}
				var M = function (e) {
					return e && "string" == typeof e ? j.a.encode(e) : ""
				}, U = function (e) {
					return e && "string" == typeof e ? j.a.decode(e) : ""
				}, R = function () {
				}, J = function (e) {
					return Object(e) === e
				}, G = {}, V = {}, z = null, q = function (t) {
					return new I.a(function () {
						var n = C()(_.a.mark((function n(r) {
							return _.a.wrap((function (n) {
								for (; ;) switch (n.prev = n.next) {
									case 0:
										if (!z || t) {
											n.next = 3;
											break
										}
										return r(z), n.abrupt("return");
									case 3:
										return n.next = 5, e.HWH5 && e.HWH5.wecodeInfo && e.HWH5.wecodeInfo({common_internal_call: !0});
									case 5:
										z = n.sent, r(z);
									case 7:
									case"end":
										return n.stop()
								}
							}), n)
						})));
						return function (e) {
							return n.apply(this, arguments)
						}
					}())
				}, K = function (e) {
					var t = k()({funcName: "hwa", data: e});
					HWH5.callMethod(t)
				}, Q = function (e) {
					var t = {
						eventId: "sre_welink_Wecode_Exception",
						extendData: k()({id: new Date - 0, code: e.code, msg: e.msg, detail: e.detail})
					};
					K(t)
				}, $ = function (t, n, r, a, o, i, c) {
					return new I.a(function () {
						var u = C()(_.a.mark((function u(s) {
							var f, l, p;
							return _.a.wrap((function (u) {
								for (; ;) switch (u.prev = u.next) {
									case 0:
										if (!n || !n.common_internal_call) {
											u.next = 2;
											break
										}
										return u.abrupt("return");
									case 2:
										if ("wecodeInfo" === r) {
											u.next = 13;
											break
										}
										if (!e.HWH5 || e.HWH5.wecodeInfo) {
											u.next = 12;
											break
										}
										return u.next = 6, me();
									case 6:
										return f = u.sent, l = f.appId, p = {
											eventId: "WELINK_ONLINE_JSAPI_HWA",
											eventLabel: "WeLink online JSAPI HWA",
											extendData: k()({
												apiname: a,
												payload: o || void 0,
												isok: !("back" === t && o),
												jssdk: E,
												time: new Date - 0,
												uri: e.location.href,
												appId: l || "",
												type: t,
												callbackId: i || void 0
											})
										}, K(p), "back" === t && o && o.data && Q({
											code: "70003",
											msg: "轻应用调用JSAPI异常",
											detail: {apiname: a, appId: l || "", url: e.location.href, payload: o.data}
										}), u.abrupt("return");
									case 12:
										q().then((function (e) {
											var n = {
												eventId: "WELINK_JSAPI_HWA",
												eventLabel: "WeLink JSAPI HWA",
												extendData: k()({
													apiname: a,
													payload: o || void 0,
													isok: !("back" === t && o),
													jssdk: E,
													time: new Date - 0,
													appId: e.appId,
													type: t,
													callbackId: i || void 0,
													schema: c || void 0
												})
											};
											K(n), "back" === t && o && o.data && Q({
												code: "70002",
												msg: "We码调用JSAPI异常",
												detail: {apiname: a, appId: e.appId, payload: o.data}
											})
										}));
									case 13:
										s();
									case 14:
									case"end":
										return u.stop()
								}
							}), u)
						})));
						return function (e) {
							return u.apply(this, arguments)
						}
					}())
				}, Y = function (e, t, n, r) {
					q().then((function (a) {
						var o = {
							eventId: "WELINK_JSAPI_HWA_FETCH",
							eventLabel: "WeLink JSAPI HWA FETCH",
							extendData: k()({apiName: e, url: t, time: n, status: r, appId: a.appId})
						};
						K(o)
					}))
				}, X = function (e, t) {
					var n = {};
					try {
						n = JSON.parse(e)
					} catch (t) {
						console.log("error occured in callback Native", e, t)
					}
					var r = U(n.data), a = J(r);
					if ("string" == typeof r && "undefined" !== r) try {
						r = JSON.parse(r), a = J(r)
					} catch (e) {
						a = !1
					}
					return a && (r = function e(t, n) {
						var r = t;
						return r.data ? r.data = e(r.data, n) : r = w()(r) ? r.map((function (t) {
							return e(t, n)
						})) : te(r, B.a, n), r
					}(r, t), r = M(k()(r)), n.data = r), n
				}, Z = function (e, t) {
					var n = {}, r = [].concat(y()(P.a), y()(T.a));
					return v()(e).forEach((function (a) {
						var o = !1;
						r.forEach((function (r) {
							a !== r.nativeName && a !== r.schema || (function (e) {
								var t = [];
								return [].concat(y()(P.a), y()(T.a)).forEach((function (n) {
									e !== n.nativeName && e !== n.schema || t.push(n)
								})), t
							}(a).length > 1 ? t.indexOf(r.apiName) >= 0 && (n[r.apiName] = e[a]) : n[r.apiName] = e[a], o = !0)
						})), o || (n[a] = e[a])
					})), n
				}, ee = function (e, t, n, r) {
					var a = t;
					"config" === e.funcName ? (a.data = JSON.parse(a.data), G.status = a.data.status, G.errorCode = a.data.errorCode, G.msg = a.data.msg, "1" === a.data.status ? (Object(A.a)("__config_ready__"), $("back", e.data, e.funcName, e.apiName, void 0, r)) : (Object(A.a)("__config_error__", G), $("back", e.data, e.funcName, e.apiName, a.data, r))) : (a.data = JSON.parse(a.data), a.data.jsApiList = Z(a.data.jsApiList, e.data.apiNameList), n(a.data))
				}, te = function (e, t, n) {
					var r = e;
					return t.forEach((function (t) {
						var n = t.origin, a = t.target;
						void 0 !== e[n] && void 0 === r[a] && (r[a] = e[n])
					})), "function" == typeof F.a[n] ? F.a[n](r) : r
				}, ne = function (e, t) {
					var n = t;
					return B.b.forEach((function (r) {
						var a = r.funcName, o = r.mapping;
						a === e && (n = te(t, o))
					})), n
				}, re = function () {
					if (!e.navigator) return !1;
					var t = e.navigator.userAgent || e.navigator.vendor || e.opera;
					return !(!/iPad|iPhone|iPod|Mac/.test(t) || e.MSStream)
				}, ae = function () {
					if (!e.navigator) return !1;
					var t = e.navigator.userAgent || e.navigator.vendor || e.opera;
					return !!/cloudlink welink workplace/.test(t)
				};
				function oe(e) {
					return v()(e).map((function (t) {
						return "".concat(encodeURIComponent(t), "=").concat(encodeURIComponent(e[t]))
					})).join("&")
				}
				var ie = function (e) {
					for (var t = "", n = new Uint8Array(e), r = n.byteLength, a = 0; a < r; a += 1) t += String.fromCharCode(n[a]);
					return M(t)
				}, ce = function (e) {
					for (var t = window.atob(e), n = t.length, r = new Uint8Array(n), a = 0; a < n; a += 1) r[a] = t.charCodeAt(a);
					return r.buffer
				}, ue = function (e) {
					var t = e;
					return t.headers && t.headers.get || !t.headers || (t.headers.get = function (e) {
						if ("string" != typeof e) return "";
						var n = e.toLocaleLowerCase(), r = v()(t.headers), a = "";
						return r.forEach((function (e) {
							if ("set-cookie" === n) re() && t.headers["Set-Cookie"] ? a = t.headers["Set-Cookie"].join(";") : t.headers["set-cookie"] && (a = t.headers["set-cookie"].join(",")); else if (n === e.toLocaleLowerCase()) if (w()(t.headers[e]) && 1 === t.headers[e].length) {
								a = t.headers[e][0]
							} else a = t.headers[e]
						})), a
					}), t
				};
				var se = new function () {
					var e = null;
					this.getGlobalUserInfo = function () {
						return e && e.corpUserId ? I.a.resolve(e) : new I.a((function (t) {
							HWH5.getUserInfo({common_internal_call: !0}).then((function (n) {
								t(e = n)
							}))
						}))
					}
				};
				var fe = new function () {
					var e = null;
					this.getGlobalAppInfo = function () {
						return e && e.language ? I.a.resolve(e) : new I.a((function (t) {
							HWH5.getAppInfo().then((function (n) {
								t(e = n)
							}))
						}))
					}
				};
				function le(e) {
					var t = e.split(";"), n = {};
					return t.forEach((function (e) {
						var t = e.split("=");
						n[t[0]] = t[1]
					})), n
				}
				function pe(e) {
					var t = JSON.parse(e);
					return t.totalBytesSent ? (t.totalBytesWritten = t.totalBytesSent, t.totalBytesExpectedToWrite = t.totalBytesExpectedToWrite ? t.totalBytesExpectedToWrite : t.totalBytesExpectedToSend) : t.totalBytesWritten && (t.totalBytesSent = t.totalBytesWritten, t.totalBytesExpectedToSend = t.totalBytesExpectedToSend ? t.totalBytesExpectedToSend : t.totalBytesExpectedToWrite), k()(t)
				}
				function de(e) {
					var t = null;
					try {
						t = JSON.parse(e)
					} catch (t) {
						return e
					}
					return F.b.forEach((function (e) {
						void 0 === t[e.origin] || t[e.target] || (t[e.target] = "string" === e.type ? "".concat(t[e.origin]) : t[e.origin])
					})), k()(t)
				}
				var he = function (e) {
					var t = function (t) {
						return e.substring(e.length - t.length, e.length) === t
					};
					return t(".dev.debug") ? "dev" : t(".debug") ? "debug" : "prod"
				};
				function me() {
					if (z && z.appId) return I.a.resolve(z);
					return new I.a((function (e) {
						var t = "h5_cb".concat(h()()), n = k()({funcName: "wecodeInfo", callbackId: t});
						HWH5.callMethod(n), function (e, t) {
							var n = HWH5.callbackNative;
							HWH5.callbackNative = function (r) {
								JSON.parse(r).callbackId === e ? t(r) : n(r)
							}
						}(t, (function (t) {
							var n = {};
							try {
								n = JSON.parse(t)
							} catch (e) {
								console.log("error occured in callback Native", t, e)
							}
							var r = U(n.data), a = null;
							try {
								a = JSON.parse(r)
							} catch (e) {
								a = null
							}
							z = a, e(a)
						}))
					}))
				}
				function ve(e) {
					return ge.apply(this, arguments)
				}
				function ge() {
					return (ge = C()(_.a.mark((function e(t) {
						var n, r, a, o, i, c;
						return _.a.wrap((function (e) {
							for (; ;) switch (e.prev = e.next) {
								case 0:
									if (n = t, !w()(n)) {
										e.next = 21;
										break
									}
									r = W(n.entries()), e.prev = 3, r.s();
								case 5:
									if ((a = r.n()).done) {
										e.next = 12;
										break
									}
									return o = p()(a.value, 2), i = o[0], c = o[1], e.next = 9, ve(c);
								case 9:
									n[i] = e.sent;
								case 10:
									e.next = 5;
									break;
								case 12:
									e.next = 17;
									break;
								case 14:
									e.prev = 14, e.t0 = e.catch(3), r.e(e.t0);
								case 17:
									return e.prev = 17, r.f(), e.finish(17);
								case 20:
									return e.abrupt("return", n);
								case 21:
									return e.next = 23, HWH5.getAbsolutePath({filePath: n}).then((function (e) {
										return n = e.filePath ? e.filePath : e.fullFilePath
									})).catch((function () {
										return n
									}));
								case 23:
									return n = e.sent, e.abrupt("return", n);
								case 25:
								case"end":
									return e.stop()
							}
						}), e, null, [[3, 14, 17, 20]])
					})))).apply(this, arguments)
				}
				function ye(e) {
					return be.apply(this, arguments)
				}
				function be() {
					return (be = C()(_.a.mark((function e(t) {
						var n, r, a, o, i, c, u;
						return _.a.wrap((function (e) {
							for (; ;) switch (e.prev = e.next) {
								case 0:
									if (t && w()(t)) {
										e.next = 3;
										break
									}
									return console.log("getSelectedDataById ids error"), e.abrupt("return", t);
								case 3:
									n = [], r = W(t.entries()), e.prev = 5, r.s();
								case 7:
									if ((a = r.n()).done) {
										e.next = 16;
										break
									}
									return o = p()(a.value, 2), o[0], i = o[1], e.next = 11, HWH5.getSelectedDataById({
										bundleName: "",
										selectedId: i
									});
								case 11:
									c = e.sent, u = c.data, n = n.concat(JSON.parse(u));
								case 14:
									e.next = 7;
									break;
								case 16:
									e.next = 21;
									break;
								case 18:
									e.prev = 18, e.t0 = e.catch(5), r.e(e.t0);
								case 21:
									return e.prev = 21, r.f(), e.finish(21);
								case 24:
									return e.abrupt("return", n);
								case 25:
								case"end":
									return e.stop()
							}
						}), e, null, [[5, 18, 21, 24]])
					})))).apply(this, arguments)
				}
				function we(e) {
					var t = e, n = v()(t);
					return t && 0 !== n.length ? (n.forEach((function (e) {
						t[e] = t[e] ? ce(t[e]) : t[e]
					})), t) : t
				}
			}).call(this, n(40))
		}, function (e, t, n) {
			e.exports = n(130)
		}, function (e, t, n) {
			e.exports = n(109)
		}, function (e, t, n) {
			var r = n(2);
			function a(e, t, n, a, o, i, c) {
				try {
					var u = e[i](c), s = u.value
				} catch (e) {
					return void n(e)
				}
				u.done ? t(s) : r.resolve(s).then(a, o)
			}
			e.exports = function (e) {
				return function () {
					var t = this, n = arguments;
					return new r((function (r, o) {
						var i = e.apply(t, n);
						function c(e) {
							a(i, r, o, c, u, "next", e)
						}
						function u(e) {
							a(i, r, o, c, u, "throw", e)
						}
						c(void 0)
					}))
				}
			}
		}, function (e, t, n) {
			e.exports = n(135)
		}, function (e, t, n) {
			(function (t) {
				var n;
				n = "undefined" != typeof window ? window : void 0 !== t ? t : "undefined" != typeof self ? self : {}, e.exports = n
			}).call(this, n(40))
		}, function (e, t) {
			var n = e.exports = {version: "2.6.11"};
			"number" == typeof __e && (__e = n)
		}, function (e, t, n) {
			"use strict";
			n.d(t, "d", (function () {
				return o
			})), n.d(t, "a", (function () {
				return u
			})), n.d(t, "e", (function () {
				return s
			})), n.d(t, "f", (function () {
				return f
			})), n.d(t, "c", (function () {
				return i
			})), n.d(t, "b", (function () {
				return l
			}));
			var r = n(21), a = n.n(r),
				o = ["selectContact", "selectContacts", "contactInfo", "getContactInfo", "selectUsers", "userInfo", "getUserInfo"],
				i = {userInfo: {}, appId: ""}, c = function (e) {
					var t = e;
					return i.userInfo = a()({}, e), t.mobileNumber && (t.mobileNumber = ""), t
				}, u = {
					selectUsers: function (e) {
						return {
							corpUserId: e.corpUserId,
							userId: e.userId,
							userNameCn: e.userNameCn,
							userNameEn: e.userNameEn,
							deptCode: e.deptCode,
							deptLevel: e.deptLevel,
							deptL1Code: e.deptL1Code,
							deptL1Name: e.deptL1Name,
							deptName: e.deptName,
							mobileNumber: "",
							userType: e.userType,
							pinyinName: e.pinyinName,
							gender: e.gender,
							signature: e.signature,
							userEmail: e.userEmail,
							workPlace: e.workPlace
						}
					}, getUserInfo: c, userInfo: c, selectContacts: function (e) {
						var t = e;
						return t.mobileCodeAll && (t.mobileCodeAll = ""), t.mobileNumber && (t.mobileNumber = ""), t.personAssistantAll && (t.personAssistantAll = ""), t.personMobileCode && (t.personMobileCode = ""), t
					}
				}, s = {required: 1, number: 2, string: 4, object: 8, array: 16, null: 32, boolean: 64, undefined: 128},
				f = {
					scanCode: {needResult: 7},
					fetch: {url: 5, method: 5, body: 4, headers: 12},
					chooseImage: {
						flag: 6,
						imagePickerMode: 4,
						maxSelectedCount: 6,
						showOrigin: 64,
						btntxtEN: 4,
						btntxtCN: 4,
						titleEN: 4,
						titleCN: 4,
						cameraFacing: 6,
						showShadow: 6,
						compress: 6
					},
					uploadFile: {
						serverType: 7,
						filePath: 21,
						serverUrl: 4,
						tokenUrl: 4,
						formData: 4,
						zip: 64,
						docType: 4,
						name: 4,
						headers: 12,
						timeout: 6,
						progress: 6
					},
					downloadToMDM: {tokenUrl: 5, docId: 5, docVersion: 4, filePath: 5, progress: 6},
					downloadFile: {url: 5, header: 4, filePath: 4},
					openFile: {filePath: 5},
					filePicker: {
						fileType: 17,
						imagePickerMode: 4,
						maxSelectedCount: 6,
						showOrigin: 64,
						btntxtCN: 4,
						btntxtEN: 4
					},
					removeFile: {path: 5},
					encryptFile: {filePath: 5},
					existInMDM: {filePath: 5},
					previewImage: {index: 7, imageArray: 5, watermark: 64},
					getAbsolutePath: {filePath: 5},
					selectedFiles: {appId: 5, packageName: 5, needCallback: 65},
					getOneBoxFiles: {
						appId: 5,
						packageName: 5,
						ownerId: 4,
						folderId: 4,
						orderField: 4,
						orderDirection: 4
					},
					uploadFileToOneBox: {appId: 5, packageName: 5, ownerId: 5, folderId: 4, localFilePath: 5},
					uploadOneBoxFileOperation: {taskId: 5, action: 5},
					downloadFileFromOneBox: {appId: 5, packageName: 5, ownerId: 5, fileId: 5},
					downloadOneBoxFileOperation: {taskId: 5, action: 5},
					openOneBoxFile: {appId: 5, packageName: 5, ownerId: 5, fileId: 5},
					saveOneBoxToMyFiles: {
						appId: 5,
						packageName: 5,
						ownerId: 5,
						fileId: 5,
						isFolder: 5,
						needCallback: 3
					},
					importOneBoxFromMyFiles: {appId: 5, packageName: 5, ownerId: 5, fileId: 5, needCallback: 3},
					deleteOneBoxFile: {appId: 5, packageName: 5, ownerId: 5, fileId: 5, isFolder: 5, needCallback: 3},
					shareOneBoxFile: {appId: 5, packageName: 5, ownerId: 5, fileId: 5, needCallback: 3},
					selectContacts: {
						needCallback: 65,
						isSingleSelection: 64,
						minimum: 2,
						maximum: 2,
						mode: 2,
						dataSourceType: 2,
						searchKeyword: 4,
						title: 4,
						users: 4,
						supportPortals: 4,
						fixedFlag: 4
					},
					selectUsers: {
						needCallback: 65,
						isSingleSelection: 64,
						minimum: 2,
						maximum: 2,
						mode: 2,
						dataSourceType: 2,
						searchKeyword: 4,
						title: 4,
						users: 4,
						supportPortals: 4,
						fixedFlag: 4
					},
					getContactInfo: {userIds: 4, corpUserIds: 4, userEmails: 4},
					openUserProfile: {userId: 4, corpUserId: 4, userEmail: 4},
					createIMGroupChat: {groupType: 3, groupMembers: 5},
					getIMGroupList: {groupIDList: 4},
					openIMChat: {chatID: 5, chatType: 5, chatName: 4},
					selectGroupMembers: {groupId: 5, isRadio: 5, needCallback: 65},
					openAudioConference: {members: 5},
					audioConferenceDirectly: {userList: 5},
					makePhoneCall: {dialNumber: 5, makeWay: 3},
					sendIMTextMessage: {toId: 5, isGroup: 5, content: 5},
					getLocation: {type: 2},
					sendIMCard: {
						receiver: 5,
						receiveType: 5,
						cardType: 5,
						receiveName: 4,
						title: 5,
						from: 5,
						subTitle: 5,
						iconURL: 5,
						sourceUrl: 5,
						iOpenURI: 4,
						aOpenURI: 4,
						handlerH5UriIOS: 4,
						handlerH5UriAndroid: 4,
						isPCDisplay: 7,
						fileID: 4,
						ownerID: 4,
						format: 4,
						fileSize: 2,
						isGotoChat: 4
					},
					share: {type: 5, data: 9},
					openWebview: {uri: 5},
					navigateToWecode: {uri: 5, extraData: 8},
					navigateBackWecode: {extraData: 9},
					setStorage: {key: 5, data: 5},
					showToast: {msg: 5, type: 5},
					loading: {status: 65},
					setNavigationBarTitle: {title: 5},
					recordAudio: {type: 5, sampleRate: 4, format: 4, encodeBitRate: 4, numberOfChannels: 4},
					playMedia: {url: 5, title: 4},
					playAudio: {url: 5, imageUrl: 4, title: 4, desc: 4, startTime: 2},
					canIUse: {schema: 17},
					getMeetingSchedules: {appId: 5, searchBeginTimeMS: 2, searchEndTimeMS: 2},
					log: {content: 5, type: 5},
					hwa: {eventId: 5, eventLabel: 5, extendData: 5},
					enableIHelp: {queryString: 4},
					zipsFiles: {filesPath: 21},
					compressImage: {filePath: 21},
					uploadImage: {
						serverType: 7,
						filePath: 21,
						serverUrl: 4,
						tokenUrl: 4,
						formData: 4,
						zip: 64,
						docType: 4,
						name: 4,
						headers: 12,
						timeout: 6,
						progress: 6,
						maxWidth: 6,
						maxHeight: 6,
						maxSize: 6
					},
					getAuthCode: {clientId: 5},
					playRecord: {uri: 4},
					voiceToText: {
						action: 5,
						appId: 4,
						appKey: 4,
						appName: 4,
						salt: 4,
						translateMode: 2,
						bos: 2,
						eos: 2,
						language: 4,
						translateLanguage: 4,
						paramPreserve: 12
					},
					refreshH5Height: {height: 6},
					queryMeetingSchedules: {bundleName: 4},
					refreshStoreCard: {appID: 4},
					startMeeting: {isVideo: 6, contacts: 4},
					socialShare: {
						type: 5,
						uri: 5,
						title: 4,
						iconUri: 4,
						desc: 4,
						from: 4,
						internalTarget: 20,
						externalTarget: 20
					},
					getBluetoothInfo: {action: 5},
					requestPayment: {traderOrderNo: 5, language: 5, title: 5, timeStamp: 5, sign: 5, version: 5},
					reward: {
						senderID: 5,
						senderNickname: 5,
						amount: 5,
						receiverID: 5,
						receiverNickname: 5,
						groupID: 4,
						greeting: 4
					},
					searchLocation: {radius: 2, longitude: 5, latitude: 5},
					setNavigationBarColor: {frontColor: 5, backgroundColor: 5},
					getDepartment: {bundleName: 5},
					managerSelector: {bundleName: 4, roleCodes: 5},
					shareToMiniProgram: {
						title: 4,
						iconUri: 4,
						desc: 4,
						from: 4,
						webpageUrl: 5,
						userName: 5,
						path: 5,
						withShareTicket: 65,
						miniprogramType: 3
					},
					setScreenBrightness: {value: 3},
					getClouddriveFilesList: {appId: 4, packageName: 4, needCallback: 2},
					uploadClouddriveFile: {appId: 5, packageName: 4, ownerId: 5, folderId: 4, localFilePath: 5},
					uploadClouddriveFileOperation: {taskId: 5, action: 5},
					downloadClouddriveFile: {appId: 5, packageName: 4, ownerId: 5, fileId: 5},
					downloadClouddriveFileOperation: {taskId: 5, action: 5},
					selectClouddriveFiles: {appId: 5, packageName: 4, needCallback: 2},
					openClouddriveFile: {appId: 4, packageName: 4, ownerId: 4, fileId: 4},
					saveClouddriveFileToMyFiles: {
						appId: 5,
						packageName: 4,
						ownerId: 5,
						fileId: 5,
						isFolder: 5,
						needCallback: 2
					},
					importClouddriveFileFromMyFiles: {
						appId: 5,
						packageName: 4,
						ownerId: 5,
						folderId: 4,
						needCallback: 2
					},
					deleteClouddriveFile: {
						appId: 5,
						packageName: 4,
						ownerId: 4,
						fileId: 5,
						isFolder: 5,
						needCallback: 2
					},
					getClouddriveFileSharelink: {appId: 5, packageName: 4, ownerId: 5, fileId: 5, isFolder: 5},
					setNavigationBar: {navigationBar: 8, navigationBarType: 2},
					sendIMFile: {toId: 5, fileType: 5, filePath: 5, isGroup: 5},
					navigateToPage: {j_p_c: !0, uri: 5, extraData: 8},
					complexChoose: {
						j_p_c: !0,
						isSingleSelection: 64,
						minimum: 2,
						maximum: 2,
						dataSourceType: 2,
						title: 4,
						users: 4,
						supportPortals: 2
					},
					viewScheduleDetail: {j_p_c: !0, uuid: 5, recurrenceId: 133},
					operateSchedule: {j_p_c: !0, uuid: 5, recurrenceId: 133, operateType: 5},
					wirelessDisplay: {j_p_c: !0, pincode: 4, ip: 4, mac: 4}
				};
			f.scanQR = f.scanCode, f.fetchInternet = f.fetch, f.imagePicker = f.chooseImage, f.openFileInMDM = f.openFile, f.deleteFile = f.removeFile, f.imageBrowser = f.previewImage, f.contactInfo = f.getContactInfo, f.viewContactInfo = f.openUserProfile, f.makingcall = f.makePhoneCall, f.makingCall = f.makePhoneCall, f.generateQRCode = f.fetch, f.enableFeedback = f.enableIHelp, f.fetchIntranet = f.fetch, f.selectUsers = f.selectContacts;
			var l = [{origin: "status", target: "statusCode", type: "string"}]
		}, function (e, t, n) {
			e.exports = n(133)
		}, function (e, t) {
			var n = e.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
			"number" == typeof __g && (__g = n)
		}, function (e, t, n) {
			var r = n(9), a = n(6), o = n(35), i = n(24), c = n(27), u = function (e, t, n) {
				var s, f, l, p = e & u.F, d = e & u.G, h = e & u.S, m = e & u.P, v = e & u.B, g = e & u.W,
					y = d ? a : a[t] || (a[t] = {}), b = y.prototype, w = d ? r : h ? r[t] : (r[t] || {}).prototype;
				for (s in d && (n = t), n) (f = !p && w && void 0 !== w[s]) && c(y, s) || (l = f ? w[s] : n[s], y[s] = d && "function" != typeof w[s] ? n[s] : v && f ? o(l, r) : g && w[s] == l ? function (e) {
					var t = function (t, n, r) {
						if (this instanceof e) {
							switch (arguments.length) {
								case 0:
									return new e;
								case 1:
									return new e(t);
								case 2:
									return new e(t, n)
							}
							return new e(t, n, r)
						}
						return e.apply(this, arguments)
					};
					return t.prototype = e.prototype, t
				}(l) : m && "function" == typeof l ? o(Function.call, l) : l, m && ((y.virtual || (y.virtual = {}))[s] = l, e & u.R && b && !b[s] && i(b, s, l)))
			};
			u.F = 1, u.G = 2, u.S = 4, u.P = 8, u.B = 16, u.W = 32, u.U = 64, u.R = 128, e.exports = u
		}, function (e, t, n) {
			var r = n(58)("wks"), a = n(46), o = n(9).Symbol, i = "function" == typeof o;
			(e.exports = function (e) {
				return r[e] || (r[e] = i && o[e] || (i ? o : a)("Symbol." + e))
			}).store = r
		}, function (e, t, n) {
			var r = [];
			r = n(128), e.exports = r
		}, function (e, t, n) {
			e.exports = n(131)
		}, function (e, t, n) {
			var r = n(25);
			e.exports = function (e) {
				if (!r(e)) throw TypeError(e + " is not an object!");
				return e
			}
		}, function (e, t, n) {
			e.exports = !n(26)((function () {
				return 7 != Object.defineProperty({}, "a", {
					get: function () {
						return 7
					}
				}).a
			}))
		}, function (e, t, n) {
			var r = [];
			r = n(93), e.exports = r
		}, function (e, t, n) {
			var r = n(68), a = n(41);
			function o(t) {
				return e.exports = o = "function" == typeof a && "symbol" == typeof r ? function (e) {
					return typeof e
				} : function (e) {
					return e && "function" == typeof a && e.constructor === a && e !== a.prototype ? "symbol" : typeof e
				}, o(t)
			}
			e.exports = o
		}, function (e, t, n) {
			var r = n(14), a = n(79), o = n(55), i = Object.defineProperty;
			t.f = n(15) ? Object.defineProperty : function (e, t, n) {
				if (r(e), t = o(t, !0), r(n), a) try {
					return i(e, t, n)
				} catch (e) {
				}
				if ("get" in n || "set" in n) throw TypeError("Accessors not supported!");
				return "value" in n && (e[t] = n.value), e
			}
		}, function (e, t, n) {
			var r = n(84), a = n(44);
			e.exports = function (e) {
				return r(a(e))
			}
		}, function (e, t, n) {
			e.exports = n(157)
		}, function (e, t, n) {
			var r = n(162);
			function a() {
				return e.exports = a = r || function (e) {
					for (var t = 1; t < arguments.length; t++) {
						var n = arguments[t];
						for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r])
					}
					return e
				}, a.apply(this, arguments)
			}
			e.exports = a
		}, function (e, t, n) {
			"use strict";
			n.d(t, "a", (function () {
				return k
			})), n.d(t, "b", (function () {
				return w
			}));
			var r = n(69), a = n.n(r), o = n(52), i = n.n(o), c = n(73), u = n.n(c), s = n(74), f = n.n(s), l = n(75),
				p = n.n(l), d = n(104), h = n.n(d), m = n(8), v = n.n(m), g = n(7);
			function y(e, t) {
				var n = v()(e);
				if (p.a) {
					var r = p()(e);
					t && (r = r.filter((function (t) {
						return f()(e, t).enumerable
					}))), n.push.apply(n, r)
				}
				return n
			}
			var b = !1, w = {
				enable: function (e) {
					b = e
				}, getState: function () {
					return b
				}
			}, x = function (e, t) {
				var n, r;
				return !!(g.e[(n = e, r = Object.prototype.toString.call(n), r.substring(8, r.length - 1).toLocaleLowerCase())] & t)
			}, k = function (e, t) {
				var n = g.f[e];
				if (!n) return !0;
				var r = function (e) {
					for (var t = 1; t < arguments.length; t++) {
						var n = null != arguments[t] ? arguments[t] : {};
						t % 2 ? y(Object(n), !0).forEach((function (t) {
							h()(e, t, n[t])
						})) : u.a ? i()(e, u()(n)) : y(Object(n)).forEach((function (t) {
							a()(e, t, f()(n, t))
						}))
					}
					return e
				}({}, n);
				return delete r.j_p_c, function (e) {
					for (var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = v()(e), r = !0, a = 0; a < n.length; a += 1) {
						var o = n[a];
						if (e[o] & g.e.required || Object.prototype.hasOwnProperty.call(t, o)) {
							if (e[o] & g.e.required && !Object.prototype.hasOwnProperty.call(t, o)) {
								r = !1;
								break
							}
							if (!x(t[o], e[o])) {
								r = !1;
								break
							}
						}
					}
					return r
				}(r, t)
			}
		}, function (e, t, n) {
			var r = n(159), a = n(160), o = n(99), i = n(161);
			e.exports = function (e) {
				return r(e) || a(e) || o(e) || i()
			}
		}, function (e, t, n) {
			var r = n(18), a = n(36);
			e.exports = n(15) ? function (e, t, n) {
				return r.f(e, t, a(1, n))
			} : function (e, t, n) {
				return e[t] = n, e
			}
		}, function (e, t) {
			e.exports = function (e) {
				return "object" == typeof e ? null !== e : "function" == typeof e
			}
		}, function (e, t) {
			e.exports = function (e) {
				try {
					return !!e()
				} catch (e) {
					return !0
				}
			}
		}, function (e, t) {
			var n = {}.hasOwnProperty;
			e.exports = function (e, t) {
				return n.call(e, t)
			}
		}, function (e, t, n) {
			"use strict";
			t.a = {
				encode: function (e) {
					var t = e;
					return null == t && (t += ""), btoa(unescape(encodeURIComponent(t)))
				}, decode: function (e) {
					return decodeURIComponent(escape(atob(e)))
				}
			}
		}, function (e, t, n) {
			"use strict";
			n.d(t, "b", (function () {
				return b
			})), n.d(t, "a", (function () {
				return w
			}));
			var r = n(2), a = n.n(r), o = n(1), i = n.n(o), c = n(3), u = n.n(c), s = n(4), f = n.n(s), l = n(103),
				p = n.n(l), d = n(0), h = n(31), m = n(7), v = {}, g = Object(h.a)(), y = function (e, t) {
					return t && m.d.indexOf(t) >= 0 ? Object(d.c)(f()(e), t) : e
				}, b = function (e) {
					var t = JSON.parse(e);
					t.callbackId && v[t.callbackId] && v[t.callbackId](t)
				}, w = function (e, t) {
					var n = "cb".concat(p()());
					if ("fetch" !== t.apiName && "fetchInternet" !== t.apiName && "fetchIntranet" !== t.apiName && "fetchVPN" !== t.apiName && "fetchRomaApi" !== t.apiName || (d.i[t.apiName + n] = new Date - 0), t && t.data && "function" == typeof t.data.onProgress && (v["progress_".concat(n)] = function (e) {
						var n = e;
						n.data = Object(d.g)(e.data), n.data = Object(d.A)(n.data), t.data.onProgress(n.data)
					}), t && t.data) {
						if ("downloadFileOperationAndEncrypt" === t.apiName && "function" == typeof HWH5.abortFileOperation) {
							v[n] = function () {
								var e = u()(i.a.mark((function e(n) {
									var r;
									return i.a.wrap((function (e) {
										for (; ;) switch (e.prev = e.next) {
											case 0:
												if (r = y(n, t.apiName), Object(d.s)("back", t.data, t.funcName, t.apiName, r), r.data = Object(d.g)(r.data), "error" === r.type) "function" == typeof t.data.onError && t.data.onError(r.data); else {
													try {
														r.data = JSON.parse(r.data)
													} catch (e) {
														console.log("error = ", e)
													}
													"function" == typeof t.data.onSuccess && HWH5.encryptFile({
														filePath: t.data.filePath,
														etype: t.data.encryptEtype,
														common_internal_call: !0
													}).then((function (e) {
														r.data.filePath = e.filePath, t.data.onSuccess(r.data)
													})).catch((function () {
														HWH5.removeFile({
															path: t.data.filePath,
															etype: t.data.deleteEtype,
															common_internal_call: !0
														}).catch((function (e) {
															console.log("common encryptFile fail remove fail ", e), HWH5.removeFile({
																path: t.data.filePath,
																common_internal_call: !0
															}), HWH5.removeFile({
																path: t.data.filePath,
																common_internal_call: !0
															}), HWH5.removeFile({
																path: t.data.filePath,
																common_internal_call: !0
															})
														})), "function" == typeof t.data.onError && t.data.onError({
															code: "10903",
															msg: "encryptFile fail"
														})
													}))
												}
											case 4:
											case"end":
												return e.stop()
										}
									}), e)
								})));
								return function (t) {
									return e.apply(this, arguments)
								}
							}(), e(n);
							var r = {
								action: "cancel",
								type: "uploadFileOperation" === t.apiName ? "upload" : "download",
								callbackId: n
							};
							return {
								abort: function () {
									return new a.a((function (e, t) {
										HWH5.abortFileOperation(r).then((function (t) {
											e(t)
										})).catch((function (e) {
											t(e)
										}))
									}))
								}
							}
						}
						if (("uploadFileOperation" === t.apiName || "downloadFileOperation" === t.apiName) && "function" == typeof HWH5.abortFileOperation) {
							v[n] = function () {
								var e = u()(i.a.mark((function e(n) {
									var r;
									return i.a.wrap((function (e) {
										for (; ;) switch (e.prev = e.next) {
											case 0:
												if (r = y(n, t.apiName), Object(d.s)("back", t.data, t.funcName, t.apiName, r), r.data = Object(d.g)(r.data), "error" === r.type) "function" == typeof t.data.onError && t.data.onError(r.data); else {
													try {
														r.data = JSON.parse(r.data)
													} catch (e) {
														console.log("")
													}
													"function" == typeof t.data.onSuccess && t.data.onSuccess(r.data)
												}
											case 4:
											case"end":
												return e.stop()
										}
									}), e)
								})));
								return function (t) {
									return e.apply(this, arguments)
								}
							}(), e(n);
							var o = {
								action: "cancel",
								type: "uploadFileOperation" === t.apiName ? "upload" : "download",
								callbackId: n
							};
							return {
								abort: function () {
									return new a.a((function (e, t) {
										HWH5.abortFileOperation(o).then((function (t) {
											e(t)
										})).catch((function (e) {
											t(e)
										}))
									}))
								}
							}
						}
					}
					t && t.data && "voiceToText" === t.funcName && ("function" == typeof t.data.onText && (v["voice_text_".concat(n)] = function (e) {
						var n = e;
						n.data = Object(d.g)(e.data), t.data.onText(n.data)
					}), "function" == typeof t.data.onTranslateText && (v["voice_translatetext_".concat(n)] = function (e) {
						var n = e;
						n.data = Object(d.g)(e.data), t.data.onTranslateText(n.data)
					}), "function" == typeof t.data.onStatusChange && (v["voice_statuschange_".concat(n)] = function (e) {
						var n = e;
						n.data = Object(d.g)(e.data), t.data.onStatusChange(n.data)
					})), t && t.data && "selectDate" === t.funcName && "function" == typeof t.data.onChange && (v["select_date_onchange_".concat(n)] = function (e) {
						var n = e;
						n.data = Object(d.g)(e.data), t.data.onChange(n.data)
					}), t && t.data && "getBluetoothInfo" === t.funcName && ("function" == typeof t.data.bluetoothInfo && (v["bluetooth_info_".concat(n)] = function (e) {
						var n = e;
						n.data = Object(d.g)(e.data), t.data.bluetoothInfo(n.data)
					}), "function" == typeof t.data.onStatusChange && (v["bluetooth_statusChange_".concat(n)] = function (e) {
						var n = e;
						n.data = Object(d.g)(e.data), t.data.onStatusChange(n.data)
					})), t && t.data && "playAudio" === t.funcName && ("function" == typeof t.data.onStart ? v["playAudio_onStart_".concat(n)] = function (e) {
						var n = e;
						n.data = Object(d.g)(e.data), t.data.onStart(n.data)
					} : v["playAudio_onStart_".concat(n)] = d.h, "function" == typeof t.data.onStop ? v["playAudio_onStop_".concat(n)] = function (e) {
						var n = e;
						n.data = Object(d.g)(e.data), t.data.onStop(n.data)
					} : v["playAudio_onStop_".concat(n)] = d.h, "function" == typeof t.data.onPause ? v["playAudio_onPause_".concat(n)] = function (e) {
						var n = e;
						n.data = Object(d.g)(e.data), t.data.onPause(n.data)
					} : v["playAudio_onPause_".concat(n)] = d.h), t && t.data && "playAudioCustom" === t.funcName && (v.backgroundAudioManager_onPlay || ["onPlay", "onStop", "onPause", "onEnded", "onTimeUpdate", "onError"].forEach((function (e) {
						v["backgroundAudioManager_".concat(e)] = function (t) {
							var n = t;
							n.data = Object(d.g)(t.data);
							var r = {};
							try {
								r = JSON.parse(n.data)
							} catch (e) {
								r = n.data
							}
							g[e] && g[e](r), "onEnded" === e && g.reset()
						}
					}))), t && t.data && "initLoc" === t.funcName && (v["onLocationChangeLoc_".concat(n)] = function (e) {
						var n = e;
						n.data = Object(d.g)(e.data), t.data.onLocationChange(n.data)
					});
					var c = {};
					return t && t.data && "location" === t.funcName && (v["getLocation_onStart_".concat(n)] = function (e) {
						var t = e;
						t.data = Object(d.g)(e.data), c.onStart(t.data)
					}), new a.a((function (r, o) {
						var s = null, l = null;
						if ("location" === t.funcName) {
							var p = t.data && t.data.timeout && t.data.timeout > 3e3 ? t.data.timeout : 3e3;
							p = t.data && t.data.coverTimeout ? 0 : p;
							c.onStart = function () {
								s = setTimeout((function () {
									o({code: "10806", message: "Get location timeout"}), v[n] = function () {
									}, clearTimeout(s)
								}), p)
							}
						}
						if (["fetch", "fetchInternet", "fetchIntranet"].indexOf(t.funcName) > -1) {
							var h = t.data && t.data.timeout ? t.data.timeout : 2e4;
							l = setTimeout((function () {
								o(f()({code: "10800", message: "timeout"})), v[n] = function () {
								}, clearTimeout(l)
							}), h)
						}
						v[n] = function () {
							var e = u()(i.a.mark((function e(c) {
								var u, f, p, h, m, v, g, b, w;
								return i.a.wrap((function (e) {
									for (; ;) switch (e.prev = e.next) {
										case 0:
											if ((u = y(c, t.apiName)).data = Object(d.g)(u.data), u.data = Object(d.j)(u.data), "fetch" !== t.apiName && "fetchInternet" !== t.apiName && "fetchIntranet" !== t.apiName && "fetchVPN" !== t.apiName || (f = new Date - 0 - d.i[t.apiName + n], Object(d.y)(t.apiName, t.data.url, f, u.type)), "error" !== u.type || "config" === t.apiName) {
												e.next = 12;
												break
											}
											if (Object(d.s)("back", t.data, t.funcName, t.apiName, u), "getCache" !== t.funcName) {
												e.next = 9;
												break
											}
											return r(null), e.abrupt("return");
										case 9:
											o(u.data), e.next = 77;
											break;
										case 12:
											if ("getAuthCode" !== t.funcName) {
												e.next = 18;
												break
											}
											if ((p = JSON.parse(u.data)) && p.code.length > 0) {
												e.next = 18;
												break
											}
											return o(u.data), Object(d.s)("back", t.data, t.funcName, t.apiName, u.data), e.abrupt("return");
										case 18:
											if (Object(d.s)("back", t.data, t.funcName, t.apiName, void 0), "fetch" !== t.funcName) {
												e.next = 23;
												break
											}
											r({
												text: function () {
													return new a.a((function (e) {
														e(u.data)
													}))
												}, json: function () {
													return new a.a((function (e) {
														try {
															u.data = JSON.parse(u.data)
														} catch (e) {
															u.data = e
														}
														e(u.data)
													}))
												}
											}), e.next = 77;
											break;
										case 23:
											if ("fetchInternet" !== t.funcName && "fetchIntranet" !== t.funcName && "fetchVPN" !== t.funcName) {
												e.next = 30;
												break
											}
											clearTimeout(l), h = JSON.parse(u.data), m = h.statusCode, v = h.header, g = h.body, b = {
												status: m,
												headers: v,
												text: function () {
													return new a.a((function (e) {
														e(g)
													}))
												},
												json: function () {
													return new a.a((function (e) {
														var t = g;
														if ("string" == typeof t) try {
															t = JSON.parse(t)
														} catch (e) {
															console.warn(e)
														}
														e(t)
													}))
												}
											}, r(Object(d.r)(b)), e.next = 77;
											break;
										case 30:
											if ("getCache" !== t.funcName || "string" != typeof u.data || "undefine" !== u.data) {
												e.next = 34;
												break
											}
											r(null), e.next = 77;
											break;
										case 34:
											if ("config" !== t.funcName && "checkJsApi" !== t.funcName) {
												e.next = 38;
												break
											}
											Object(d.d)(t, u, r, n), e.next = 77;
											break;
										case 38:
											if ("getAppInfo" !== t.funcName) {
												e.next = 44;
												break
											}
											u.data = JSON.parse(u.data), (!t.data || t.data && !t.data.needNet) && delete u.data.net, r(u.data), e.next = 77;
											break;
										case 44:
											if ("getBluetoothDevices" !== t.funcName) {
												e.next = 50;
												break
											}
											for (u.data = JSON.parse(u.data), w = 0; w < u.data.devices.length; w += 1) u.data.devices[w].advertisData && (u.data.devices[w].advertisData = Object(d.b)(u.data.devices[w].advertisData)), u.data.devices[w].serviceData && (u.data.devices[w].serviceData = Object(d.z)(u.data.devices[w].serviceData));
											r(u.data), e.next = 77;
											break;
										case 50:
											if ("location" !== t.funcName) {
												e.next = 56;
												break
											}
											clearTimeout(s), u.data = JSON.parse(u.data), r(u.data), e.next = 77;
											break;
										case 56:
											if ("fetch" !== t.funcName) {
												e.next = 60;
												break
											}
											clearTimeout(l), e.next = 77;
											break;
										case 60:
											if ("complexChoose" !== t.apiName) {
												e.next = 75;
												break
											}
											if (e.prev = 61, u.data = JSON.parse(u.data), !t.data || Object(d.u)()) {
												e.next = 67;
												break
											}
											return e.next = 66, Object(d.l)(u.data.data);
										case 66:
											u.data.data = e.sent;
										case 67:
											e.next = 72;
											break;
										case 69:
											e.prev = 69, e.t0 = e.catch(61), console.log("complexChoose error", e.t0, u.data);
										case 72:
											r(u.data), e.next = 77;
											break;
										case 75:
											if ("string" == typeof u.data && "undefined" !== u.data) try {
												u.data = JSON.parse(u.data)
											} catch (e) {
												console.log("")
											}
											r(u.data);
										case 77:
										case"end":
											return e.stop()
									}
								}), e, null, [[61, 69]])
							})));
							return function (t) {
								return e.apply(this, arguments)
							}
						}(), e(n)
					}))
				}
		}, function (e, t) {
			e.exports = {}
		}, function (e, t, n) {
			"use strict";
			n.d(t, "a", (function () {
				return f
			})), n.d(t, "b", (function () {
				return p
			}));
			var r = n(17), a = n.n(r), o = n(8), i = n.n(o), c = n(52), u = n.n(c);
			var s = new function () {
				var e = "", t = 0, n = !1, r = !1, a = 1, o = "";
				u()(this, {
					url: {
						configurable: !0, get: function () {
							return e
						}, set: function (t) {
							var n = t !== e;
							e = t, n && this.onAttrChange("url", t)
						}
					}, startTime: {
						configurable: !0, get: function () {
							return t
						}, set: function (e) {
							t = e
						}
					}, background: {
						configurable: !0, get: function () {
							return n
						}, set: function (e) {
							var t = e !== n;
							n = e, t && this.onAttrChange("background", e)
						}
					}, repeat: {
						configurable: !0, get: function () {
							return r
						}, set: function (e) {
							var t = e !== r;
							r = e, t && this.onAttrChange("repeat", e)
						}
					}, playbackSpeed: {
						configurable: !0, get: function () {
							return a
						}, set: function (e) {
							var t = e !== a;
							a = e, t && this.onAttrChange("playbackSpeed", e)
						}
					}, cookies: {
						configurable: !0, get: function () {
							return o
						}, set: function (e) {
							o = e
						}
					}
				}), this.reset = function () {
					t = 0
				}
			};
			function f() {
				return s
			}
			var l = {
				play: {
					url: "string",
					startTime: "number",
					background: "boolean",
					repeat: "boolean",
					playbackSpeed: "number"
				},
				pause: {},
				stop: {},
				seek: {position: "number"},
				playbackSpeed: {playbackSpeed: "number"},
				repeat: {repeat: "boolean"},
				background: {background: "boolean"},
				cookies: {cookies: "string"}
			}, p = function (e) {
				var t = {status: 1, msg: ""}, n = i()(l[e.action]), r = "";
				return n.forEach((function (t) {
					var n = a()(e.data[t]);
					r || n === l[e.action][t] || (r = t)
				})), r && (t.status = 0, t.msg = "The '".concat(r, "' parameter is incorrect. Please check the documentation.")), t
			}
		}, function (e, t, n) {
			"use strict";
			n.d(t, "b", (function () {
				return a
			})), n.d(t, "a", (function () {
				return o
			}));
			var r = {}, a = function (e, t) {
				r[e] || (r[e] = []), r[e].push(t)
			}, o = function (e) {
				for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), a = 1; a < t; a++) n[a - 1] = arguments[a];
				if ("string" == typeof e) {
					var o = r[e];
					o && (delete r[e], o.forEach((function (e) {
						e.apply(void 0, n)
					})))
				}
			}
		}, function (e, t, n) {
			"use strict";
			var r = n(110)(!0);
			n(78)(String, "String", (function (e) {
				this._t = String(e), this._i = 0
			}), (function () {
				var e, t = this._t, n = this._i;
				return n >= t.length ? {value: void 0, done: !0} : (e = r(t, n), this._i += e.length, {
					value: e,
					done: !1
				})
			}))
		}, function (e, t) {
			e.exports = !0
		}, function (e, t, n) {
			var r = n(45);
			e.exports = function (e, t, n) {
				if (r(e), void 0 === t) return e;
				switch (n) {
					case 1:
						return function (n) {
							return e.call(t, n)
						};
					case 2:
						return function (n, r) {
							return e.call(t, n, r)
						};
					case 3:
						return function (n, r, a) {
							return e.call(t, n, r, a)
						}
				}
				return function () {
					return e.apply(t, arguments)
				}
			}
		}, function (e, t) {
			e.exports = function (e, t) {
				return {enumerable: !(1 & e), configurable: !(2 & e), writable: !(4 & e), value: t}
			}
		}, function (e, t, n) {
			var r = n(83), a = n(59);
			e.exports = Object.keys || function (e) {
				return r(e, a)
			}
		}, function (e, t) {
			var n = {}.toString;
			e.exports = function (e) {
				return n.call(e).slice(8, -1)
			}
		}, function (e, t, n) {
			var r = n(44);
			e.exports = function (e) {
				return Object(r(e))
			}
		}, function (e, t) {
			var n;
			n = function () {
				return this
			}();
			try {
				n = n || new Function("return this")()
			} catch (e) {
				"object" == typeof window && (n = window)
			}
			e.exports = n
		}, function (e, t, n) {
			e.exports = n(144)
		}, function (e, t, n) {
			var r = [];
			r = n(129), e.exports = r
		}, function (e, t, n) {
			"use strict";
			n.d(t, "c", (function () {
				return I
			})), n.d(t, "a", (function () {
				return O
			})), n.d(t, "b", (function () {
				return _
			}));
			var r = n(1), a = n.n(r), o = n(13), i = n.n(o), c = n(8), u = n.n(c), s = n(3), f = n.n(s), l = n(2),
				p = n.n(l), d = n(4), h = n.n(d), m = n(102), v = n.n(m), g = n(28), y = n(29), b = n(12), w = n.n(b),
				x = n(0), k = n(22), N = n(7), _ = function (e) {
					return Object(y.a)((function (t) {
						var n = h()({
							url: e.uri || e.url || e.schema + (e.data ? "?".concat(v.a.stringify(e.data)) : ""),
							callbackId: t
						});
						Object(x.s)("action", e.data, e.schema, e.apiName, void 0, t), HWH5.openURI(n)
					}), e)
				}, S = function (e) {
					return Object(y.a)((function (t) {
						var n = h()({
							url: e.uri || e.url || e.schema + (e.data ? "?data=".concat(g.a.encode(e.data)) : ""),
							callbackId: t
						});
						Object(x.s)("action", e.data, e.schema, e.apiName, void 0, t), HWH5.openURI(n)
					}), e)
				}, C = {
					viewContactInfo: ["w3account", "employeeNumber", "personMail"],
					contactInfo: ["w3accounts", "employeeNumbers", "personMails"],
					refreshTodo: [{name: "isRefresh", default: 1}, "reserve1", "reserve2"]
				}, O = function (e, t, n) {
					HWH5[e] = function (r) {
						return new p.a(function () {
							var o = f()(a.a.mark((function o(c, s) {
								var f, l, p, d, m, v, g, y;
								return a.a.wrap((function (a) {
									for (; ;) switch (a.prev = a.next) {
										case 0:
											if (Object(x.w)() && n && console.warn("“".concat(e, "” 暂不支持PC")), f = Object(x.x)(e, r), l = t, "openWebview" !== e && "openSchema" !== e) {
												a.next = 12;
												break
											}
											if (!(l = f.url || f.uri) || 0 !== l.indexOf("ui://") && 0 !== l.indexOf("method://") || Object(x.s)("action", void 0, e, e, void 0, void 0, l.split("?")[0]), !(l && l.indexOf("wecodeDefine1") > -1)) {
												a.next = 10;
												break
											}
											return s({
												code: "30803",
												message: "The URI contains invalid keywords.",
												type: "error"
											}), a.abrupt("return");
										case 10:
											a.next = 13;
											break;
										case 12:
											if (e in C) for (p = C[e], d = 0; d < p.length; d += 1) "string" == typeof (m = p[d]) ? f[m] = f[m] || "" : f[m.name] = f[m.name] || m.default;
										case 13:
											if (["selectClouddriveFiles", "openClouddriveFile", "importClouddriveFileFromMyFiles", "saveClouddriveFileToMyFiles", "deleteClouddriveFile", "getClouddriveFileSharelink"].indexOf(e) > -1 && ("WeCode", f && u()(f).length > 0 ? f.packageName = f.packageName ? f.packageName : "WeCode" : f = {packageName: "WeCode"}, "openClouddriveFile" !== e && (f.needCallback = 1)), "getDepartment" !== e && "selectPhoneContact" !== e && "openSkyTone" !== e && "queryMeetingSchedules" !== e && "viewScheduleDetail" !== e && "operateSchedule" !== e) {
												a.next = 20;
												break
											}
											return a.next = 17, Object(x.n)();
										case 17:
											v = a.sent, f && u()(f).length > 0 ? f.bundleName = f.bundleName || v.appId : f = {bundleName: v.appId}, f.needCallback = !0;
										case 20:
											if ("openWebview" !== e) {
												a.next = 25;
												break
											}
											return a.next = 23, Object(x.n)();
										case 23:
											g = a.sent, o = l, b = g.appId, w = void 0, O = void 0, I = void 0, w = o.split("?")[0].split("#")[0], O = o.match(/#.*/gi) ? o.match(/#.*/gi)[0] : "", I = (o.match(/\?.*/gi) ? o.match(/\?.*/gi)[0] : "").split("#")[0], l = w + (I += "".concat(I ? "&" : "?", "hwa_trace_source=wecode_").concat(b)) + O;
										case 25:
											if ("selectContacts" !== e && "selectUsers" !== e && "managerSelector" !== e && "complexChoose" !== e || f && !f.bundleName && (f.bundleName = "welink.wecode"), "complexChoose" === e && f && (f.callType = "WeCode", f.needCallback = !0), "getLocalFiles" === e && f && (f.needCallback = !0), "writeMail" !== e) {
												a.next = 44;
												break
											}
											if (a.prev = 29, y = null, !(y = JSON.parse(f)).action_send_multiple || !i()(y.action_send_multiple)) {
												a.next = 37;
												break
											}
											return a.next = 35, Object(x.k)(y.action_send_multiple);
										case 35:
											y.action_send_multiple = a.sent, f = h()(y);
										case 37:
											a.next = 42;
											break;
										case 39:
											a.prev = 39, a.t0 = a.catch(29), console.log("writeMail data parse error");
										case 42:
											return c(S({schema: l, data: f, apiName: e})), a.abrupt("return");
										case 44:
											if (["searchLocation", "sendIMFile", "speechToText"].indexOf(e) >= 0 && (f ? f.needCallback = 1 : f = {needCallback: 1}), "createIMGroupChat" === e && f && 0 === f.isGotoChat && (f.needCallback = !0), "ocr" === e && (l = 1 === f ? "ui://welink.openai/ocr-document" : "ui://welink.openai/ocr-invoice", f = {
												type: f,
												needCallback: 1
											}), "openMeeting" === e && (f && Object(x.v)(f) || (f = {itEventType: 4}), f.type && (f.itEventType = f.type, delete f.type)), !(k.b.getState() || N.f[e] && N.f[e].j_p_c) || Object(k.a)(e, f)) {
												a.next = 52;
												break
											}
											return s({
												code: "10802",
												message: "The parameter is incorrect. Please check the documentation",
												type: "error"
											}), a.abrupt("return");
										case 52:
											"openWebview" !== e && "openSchema" !== e || (f = null), c(_({
												schema: l,
												data: f,
												apiName: e
											}));
										case 54:
										case"end":
											return a.stop()
									}
									var o, b, w, O, I
								}), o, null, [[29, 39]])
							})));
							return function (e, t) {
								return o.apply(this, arguments)
							}
						}())
					}
				}, I = function () {
					for (var e = 0; e < w.a.length; e += 1) {
						var t = w.a[e];
						O(t.apiName, t.schema, t.pcNotSupport)
					}
				}
		}, function (e, t) {
			e.exports = function (e) {
				if (null == e) throw TypeError("Can't call method on  " + e);
				return e
			}
		}, function (e, t) {
			e.exports = function (e) {
				if ("function" != typeof e) throw TypeError(e + " is not a function!");
				return e
			}
		}, function (e, t) {
			var n = 0, r = Math.random();
			e.exports = function (e) {
				return "Symbol(".concat(void 0 === e ? "" : e, ")_", (++n + r).toString(36))
			}
		}, function (e, t, n) {
			var r = n(18).f, a = n(27), o = n(11)("toStringTag");
			e.exports = function (e, t, n) {
				e && !a(e = n ? e : e.prototype, o) && r(e, o, {configurable: !0, value: t})
			}
		}, function (e, t, n) {
			n(115);
			for (var r = n(9), a = n(24), o = n(30), i = n(11)("toStringTag"), c = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), u = 0; u < c.length; u++) {
				var s = c[u], f = r[s], l = f && f.prototype;
				l && !l[i] && a(l, i, s), o[s] = o.Array
			}
		}, function (e, t) {
			t.f = Object.getOwnPropertySymbols
		}, function (e, t) {
			t.f = {}.propertyIsEnumerable
		}, function (e, t, n) {
			e.exports = n(150)
		}, function (e, t, n) {
			e.exports = n(166)
		}, function (e, t) {
			var n = Math.ceil, r = Math.floor;
			e.exports = function (e) {
				return isNaN(e = +e) ? 0 : (e > 0 ? r : n)(e)
			}
		}, function (e, t, n) {
			var r = n(25), a = n(9).document, o = r(a) && r(a.createElement);
			e.exports = function (e) {
				return o ? a.createElement(e) : {}
			}
		}, function (e, t, n) {
			var r = n(25);
			e.exports = function (e, t) {
				if (!r(e)) return e;
				var n, a;
				if (t && "function" == typeof (n = e.toString) && !r(a = n.call(e))) return a;
				if ("function" == typeof (n = e.valueOf) && !r(a = n.call(e))) return a;
				if (!t && "function" == typeof (n = e.toString) && !r(a = n.call(e))) return a;
				throw TypeError("Can't convert object to primitive value")
			}
		}, function (e, t, n) {
			var r = n(53), a = Math.min;
			e.exports = function (e) {
				return e > 0 ? a(r(e), 9007199254740991) : 0
			}
		}, function (e, t, n) {
			var r = n(58)("keys"), a = n(46);
			e.exports = function (e) {
				return r[e] || (r[e] = a(e))
			}
		}, function (e, t, n) {
			var r = n(6), a = n(9), o = a["__core-js_shared__"] || (a["__core-js_shared__"] = {});
			(e.exports = function (e, t) {
				return o[e] || (o[e] = void 0 !== t ? t : {})
			})("versions", []).push({
				version: r.version,
				mode: n(34) ? "pure" : "global",
				copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
			})
		}, function (e, t) {
			e.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")
		}, function (e, t, n) {
			var r = n(38), a = n(11)("toStringTag"), o = "Arguments" == r(function () {
				return arguments
			}());
			e.exports = function (e) {
				var t, n, i;
				return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function (e, t) {
					try {
						return e[t]
					} catch (e) {
					}
				}(t = Object(e), a)) ? n : o ? r(t) : "Object" == (i = r(t)) && "function" == typeof t.callee ? "Arguments" : i
			}
		}, function (e, t, n) {
			var r = n(60), a = n(11)("iterator"), o = n(30);
			e.exports = n(6).getIteratorMethod = function (e) {
				if (null != e) return e[a] || e["@@iterator"] || o[r(e)]
			}
		}, function (e, t, n) {
			"use strict";
			var r = n(45);
			function a(e) {
				var t, n;
				this.promise = new e((function (e, r) {
					if (void 0 !== t || void 0 !== n) throw TypeError("Bad Promise constructor");
					t = e, n = r
				})), this.resolve = r(t), this.reject = r(n)
			}
			e.exports.f = function (e) {
				return new a(e)
			}
		}, function (e, t, n) {
			t.f = n(11)
		}, function (e, t, n) {
			var r = n(9), a = n(6), o = n(34), i = n(63), c = n(18).f;
			e.exports = function (e) {
				var t = a.Symbol || (a.Symbol = o ? {} : r.Symbol || {});
				"_" == e.charAt(0) || e in t || c(t, e, {value: i.f(e)})
			}
		}, function (e, t, n) {
			var r = n(83), a = n(59).concat("length", "prototype");
			t.f = Object.getOwnPropertyNames || function (e) {
				return r(e, a)
			}
		}, function (e, t, n) {
			var r = n(50), a = n(36), o = n(19), i = n(55), c = n(27), u = n(79), s = Object.getOwnPropertyDescriptor;
			t.f = n(15) ? s : function (e, t) {
				if (e = o(e), t = i(t, !0), u) try {
					return s(e, t)
				} catch (e) {
				}
				if (c(e, t)) return a(!r.f.call(e, t), e[t])
			}
		}, function (e, t, n) {
			e.exports = n(141)
		}, function (e, t, n) {
			e.exports = n(143)
		}, function (e, t, n) {
			e.exports = n(168)
		}, function (e, t, n) {
			var r = n(152), a = n(153), o = n(99), i = n(156);
			e.exports = function (e, t) {
				return r(e) || a(e, t) || o(e, t) || i()
			}
		}, function (e) {
			e.exports = JSON.parse('{"package":"com.huawei.works.h5.common","packageAlias":"common","versionCode":"23","versionName":"1.0.23","indexURL":"h5://common/html/index.html","minAdaptedCode":"135"}')
		}, function (e, t, n) {
			"use strict";
			n.d(t, "a", (function () {
				return r
			})), n.d(t, "b", (function () {
				return a
			}));
			var r = [{origin: "chineseName", target: "userNameCn"}, {
				origin: "englishName",
				target: "userNameEn"
			}, {origin: "employeeNumber", target: "corpUserId"}, {
				origin: "mobileCodeAll",
				target: "mobileNumber"
			}, {origin: "personLocation", target: "workPlace"}, {
				origin: "personMail",
				target: "userEmail"
			}, {origin: "personType", target: "userType"}, {origin: "sex", target: "gender"}, {
				origin: "w3account",
				target: "userId"
			}, {origin: "sign", target: "signature"}], a = [{
				funcName: "getContactInfo",
				mapping: [{origin: "userIds", target: "w3accounts"}, {
					origin: "corpUserIds",
					target: "employeeNumbers"
				}, {origin: "userEmails", target: "personMails"}]
			}, {
				funcName: "contactInfo",
				mapping: [{origin: "userIds", target: "w3accounts"}, {
					origin: "corpUserIds",
					target: "employeeNumbers"
				}, {origin: "userEmails", target: "personMails"}]
			}, {
				funcName: "openUserProfile",
				mapping: [{origin: "userId", target: "w3account"}, {
					origin: "corpUserId",
					target: "employeeNumber"
				}, {origin: "userEmail", target: "personMail"}]
			}, {
				funcName: "viewContactInfo",
				mapping: [{origin: "userId", target: "w3account"}, {
					origin: "corpUserId",
					target: "employeeNumber"
				}, {origin: "userEmail", target: "personMail"}]
			}, {funcName: "fetchInternet", mapping: []}, {funcName: "fetchVPN", mapping: []}]
		}, function (e, t, n) {
			e.exports = n(170)
		}, function (e, t, n) {
			e.exports = n(173)
		}, function (e, t, n) {
			e.exports = n(175)
		}, function (e, t, n) {
			"use strict";
			var r = n(20), a = n.n(r), o = n(17), i = n.n(o), c = {}, u = {
				watermark_id: "wm_div_id",
				watermark_prefix: "mask_div_id",
				watermark_txt: "测试水印",
				watermark_x: 20,
				watermark_y: 20,
				watermark_rows: 0,
				watermark_cols: 0,
				watermark_x_space: 100,
				watermark_y_space: 50,
				watermark_font: "微软雅黑",
				watermark_color: "black",
				watermark_fontsize: "18px",
				watermark_alpha: .15,
				watermark_width: 100,
				watermark_height: 100,
				watermark_angle: 15,
				watermark_parent_width: 0,
				watermark_parent_height: 0,
				watermark_parent_node: null
			}, s = function (e) {
				if (1 === arguments.length && "object" === i()(arguments[0])) {
					var t = arguments[0] || {};
					for (var n in t) t[n] && u[n] && t[n] === u[n] || (t[n] || 0 === t[n]) && (u[n] = t[n])
				}
				var r = document.getElementById(u.watermark_id);
				if (r) {
					var o = r.parentNode;
					o && o.removeChild(r)
				}
				Math.max(document.body.scrollWidth, document.body.clientWidth), u.watermark_width, Math.max(document.body.scrollHeight, document.body.clientHeight, document.documentElement.clientHeight), u.watermark_height;
				var c = arguments[0] || {}, s = u.watermark_parent_node, f = 0, l = 0;
				c.watermark_parent_width || c.watermark_parent_height ? (c.watermark_parent_width ? c.watermark_parent_width - u.watermark_width / 2 : u.watermark_parent_node && s.offsetWidth - u.watermark_width / 2, c.watermark_parent_height ? c.watermark_parent_height - u.watermark_height / 2 : u.watermark_parent_node && Math.max(s.offsetHeight, s.scrollHeight) - u.watermark_height / 2, s && (f = s.offsetTop || 0, l = s.offsetLeft || 0, u.watermark_x = u.watermark_x + l, u.watermark_y = u.watermark_y + f)) : s && (f = s.offsetTop || 0, l = s.offsetLeft || 0, s.offsetWidth - u.watermark_width / 2 || 0, Math.max(s.offsetHeight, s.scrollHeight) - u.watermark_height / 2 || 0, u.watermark_x = u.watermark_x + l, u.watermark_y = u.watermark_y + f);
				var p, d, h = document.getElementById(u.watermark_id), m = {};
				if (h) h.shadowRoot && (m = h.shadowRoot); else {
					(h = document.createElement("div")).id = u.watermark_id, h.style.pointerEvents = "none", m = "function" == typeof h.attachShadow ? h.attachShadow({mode: "open"}) : h;
					var v = document.body.children, g = a()() + "", y = g.substr(g.length - 1, 1);
					v[y] ? document.body.insertBefore(h, v[y]) : document.body.appendChild(h)
				}
				var b = document.createElement("div");
				b.style.width = "100%", b.style.position = "fixed", b.style.top = "0", b.style.overflow = "hidden", b.style.bottom = "0", b.style.pointerEvents = "none", m.appendChild(b);
				for (var w = 0; w < u.watermark_rows; w++) {
					var x = w % 2 == 0;
					d = u.watermark_y + (u.watermark_y_space + u.watermark_height) * w;
					for (var k = 0; k < u.watermark_cols; k++) {
						p = u.watermark_x + (u.watermark_width + u.watermark_x_space) * k;
						var N = document.createElement("div"), _ = document.createTextNode(u.watermark_txt);
						N.appendChild(_), N.id = u.watermark_prefix + w + k, N.style.webkitTransform = "rotate(-" + u.watermark_angle + "deg)", N.style.MozTransform = "rotate(-" + u.watermark_angle + "deg)", N.style.msTransform = "rotate(-" + u.watermark_angle + "deg)", N.style.OTransform = "rotate(-" + u.watermark_angle + "deg)", N.style.transform = "rotate(-" + u.watermark_angle + "deg)", N.style.visibility = "", N.style.position = "absolute", N.style.left = x ? p + "px" : p - u.watermark_width + "px", N.style.top = d + "px", N.style.overflow = "hidden", N.style.zIndex = "9999999", N.style.opacity = u.watermark_alpha, N.style.fontSize = u.watermark_fontsize, N.style.fontFamily = u.watermark_font, N.style.color = u.watermark_color, N.style.textAlign = "center", N.style.width = u.watermark_width + "px", N.style.height = u.watermark_height + "px", N.style.display = "block", N.style["-ms-user-select"] = "none", b.appendChild(N)
					}
				}
				m.appendChild(b)
			};
			c.init = function (e) {
				window.addEventListener("load", (function () {
					s(e)
				})), window.addEventListener("resize", (function () {
					s(e)
				})), window.addEventListener("DOMContentLoaded", (function () {
					s(e)
				}))
			}, c.load = function (e) {
				s(e)
			}, c.remove = function () {
				!function () {
					if (1 === arguments.length && "object" === i()(arguments[0])) {
						var e = arguments[0] || {};
						for (key in e) e[key] && u[key] && e[key] === u[key] || (e[key] || 0 === e[key]) && (u[key] = e[key])
					}
					var t = document.getElementById(u.watermark_id), n = t.parentNode;
					n.removeChild(t)
				}()
			}, t.a = c
		}, function (e, t) {
		}, function (e, t, n) {
			"use strict";
			var r = n(34), a = n(10), o = n(80), i = n(24), c = n(30), u = n(111), s = n(47), f = n(114),
				l = n(11)("iterator"), p = !([].keys && "next" in [].keys()), d = function () {
					return this
				};
			e.exports = function (e, t, n, h, m, v, g) {
				u(n, t, h);
				var y, b, w, x = function (e) {
						if (!p && e in S) return S[e];
						switch (e) {
							case"keys":
							case"values":
								return function () {
									return new n(this, e)
								}
						}
						return function () {
							return new n(this, e)
						}
					}, k = t + " Iterator", N = "values" == m, _ = !1, S = e.prototype,
					C = S[l] || S["@@iterator"] || m && S[m], O = C || x(m), I = m ? N ? x("entries") : O : void 0,
					j = "Array" == t && S.entries || C;
				if (j && (w = f(j.call(new e))) !== Object.prototype && w.next && (s(w, k, !0), r || "function" == typeof w[l] || i(w, l, d)), N && C && "values" !== C.name && (_ = !0, O = function () {
					return C.call(this)
				}), r && !g || !p && !_ && S[l] || i(S, l, O), c[t] = O, c[k] = d, m) if (y = {
					values: N ? O : x("values"),
					keys: v ? O : x("keys"),
					entries: I
				}, g) for (b in y) b in S || o(S, b, y[b]); else a(a.P + a.F * (p || _), t, y);
				return y
			}
		}, function (e, t, n) {
			e.exports = !n(15) && !n(26)((function () {
				return 7 != Object.defineProperty(n(54)("div"), "a", {
					get: function () {
						return 7
					}
				}).a
			}))
		}, function (e, t, n) {
			e.exports = n(24)
		}, function (e, t, n) {
			var r = n(14), a = n(82), o = n(59), i = n(57)("IE_PROTO"), c = function () {
			}, u = function () {
				var e, t = n(54)("iframe"), r = o.length;
				for (t.style.display = "none", n(85).appendChild(t), t.src = "javascript:", (e = t.contentWindow.document).open(), e.write("<script>document.F=Object<\/script>"), e.close(), u = e.F; r--;) delete u.prototype[o[r]];
				return u()
			};
			e.exports = Object.create || function (e, t) {
				var n;
				return null !== e ? (c.prototype = r(e), n = new c, c.prototype = null, n[i] = e) : n = u(), void 0 === t ? n : a(n, t)
			}
		}, function (e, t, n) {
			var r = n(18), a = n(14), o = n(37);
			e.exports = n(15) ? Object.defineProperties : function (e, t) {
				a(e);
				for (var n, i = o(t), c = i.length, u = 0; c > u;) r.f(e, n = i[u++], t[n]);
				return e
			}
		}, function (e, t, n) {
			var r = n(27), a = n(19), o = n(112)(!1), i = n(57)("IE_PROTO");
			e.exports = function (e, t) {
				var n, c = a(e), u = 0, s = [];
				for (n in c) n != i && r(c, n) && s.push(n);
				for (; t.length > u;) r(c, n = t[u++]) && (~o(s, n) || s.push(n));
				return s
			}
		}, function (e, t, n) {
			var r = n(38);
			e.exports = Object("z").propertyIsEnumerable(0) ? Object : function (e) {
				return "String" == r(e) ? e.split("") : Object(e)
			}
		}, function (e, t, n) {
			var r = n(9).document;
			e.exports = r && r.documentElement
		}, function (e, t, n) {
			var r = n(14);
			e.exports = function (e, t, n, a) {
				try {
					return a ? t(r(n)[0], n[1]) : t(n)
				} catch (t) {
					var o = e.return;
					throw void 0 !== o && r(o.call(e)), t
				}
			}
		}, function (e, t, n) {
			var r = n(30), a = n(11)("iterator"), o = Array.prototype;
			e.exports = function (e) {
				return void 0 !== e && (r.Array === e || o[a] === e)
			}
		}, function (e, t, n) {
			var r = n(14), a = n(45), o = n(11)("species");
			e.exports = function (e, t) {
				var n, i = r(e).constructor;
				return void 0 === i || null == (n = r(i)[o]) ? t : a(n)
			}
		}, function (e, t, n) {
			var r, a, o, i = n(35), c = n(121), u = n(85), s = n(54), f = n(9), l = f.process, p = f.setImmediate,
				d = f.clearImmediate, h = f.MessageChannel, m = f.Dispatch, v = 0, g = {}, y = function () {
					var e = +this;
					if (g.hasOwnProperty(e)) {
						var t = g[e];
						delete g[e], t()
					}
				}, b = function (e) {
					y.call(e.data)
				};
			p && d || (p = function (e) {
				for (var t = [], n = 1; arguments.length > n;) t.push(arguments[n++]);
				return g[++v] = function () {
					c("function" == typeof e ? e : Function(e), t)
				}, r(v), v
			}, d = function (e) {
				delete g[e]
			}, "process" == n(38)(l) ? r = function (e) {
				l.nextTick(i(y, e, 1))
			} : m && m.now ? r = function (e) {
				m.now(i(y, e, 1))
			} : h ? (o = (a = new h).port2, a.port1.onmessage = b, r = i(o.postMessage, o, 1)) : f.addEventListener && "function" == typeof postMessage && !f.importScripts ? (r = function (e) {
				f.postMessage(e + "", "*")
			}, f.addEventListener("message", b, !1)) : r = "onreadystatechange" in s("script") ? function (e) {
				u.appendChild(s("script")).onreadystatechange = function () {
					u.removeChild(this), y.call(e)
				}
			} : function (e) {
				setTimeout(i(y, e, 1), 0)
			}), e.exports = {set: p, clear: d}
		}, function (e, t) {
			e.exports = function (e) {
				try {
					return {e: !1, v: e()}
				} catch (e) {
					return {e: !0, v: e}
				}
			}
		}, function (e, t, n) {
			var r = n(14), a = n(25), o = n(62);
			e.exports = function (e, t) {
				if (r(e), a(t) && t.constructor === e) return t;
				var n = o.f(e);
				return (0, n.resolve)(t), n.promise
			}
		}, function (e, t, n) {
			var r = n(11)("iterator"), a = !1;
			try {
				var o = [7][r]();
				o.return = function () {
					a = !0
				}, Array.from(o, (function () {
					throw 2
				}))
			} catch (e) {
			}
			e.exports = function (e, t) {
				if (!t && !a) return !1;
				var n = !1;
				try {
					var o = [7], i = o[r]();
					i.next = function () {
						return {done: n = !0}
					}, o[r] = function () {
						return i
					}, e(o)
				} catch (e) {
				}
				return n
			}
		}, function (e, t) {
			e.exports = [{apiName: "getDeviceInfo", nativeName: "getDeviceInfo"}, {
				apiName: "getAppInfo",
				nativeName: "getAppInfo"
			}, {apiName: "getNetworkType", nativeName: "getNetworkStatus"}, {
				apiName: "scanCode",
				nativeName: "scanQR"
			}, {apiName: "navigateBack", nativeName: "goBack"}, {
				apiName: "getUserInfo",
				nativeName: "getUserInfo"
			}, {apiName: "getAuthCode", nativeName: "getAuthCode"}, {
				apiName: "config",
				nativeName: "config"
			}, {apiName: "checkJsApi", nativeName: "checkJsApi"}, {
				apiName: "getLocation",
				nativeName: "location"
			}, {apiName: "playAudio", nativeName: "playAudio"}, {
				apiName: "share",
				nativeName: "share"
			}, {apiName: "playMedia", nativeName: "playMedia"}, {
				apiName: "setStorage",
				nativeName: "setCache"
			}, {apiName: "getStorage", nativeName: "getCache"}, {
				apiName: "clearStorage",
				nativeName: "clearCache"
			}, {apiName: "removeStorage", nativeName: "deleteCache"}, {
				apiName: "recordAudio",
				nativeName: "broadcastEvent"
			}, {apiName: "previewImage", nativeName: "imageBrowser"}, {
				apiName: "launchApp",
				nativeName: "launchApp"
			}, {apiName: "close", nativeName: "close"}, {
				apiName: "setNavigationBarTitle",
				nativeName: "setNavTitle"
			}, {apiName: "uploadImage", nativeName: "uploadFile"}, {
				apiName: "chooseImage",
				nativeName: "imagePicker"
			}, {apiName: "openFile", nativeName: "openFileInMDM"}, {
				apiName: "navigateToWecode",
				nativeName: "navigateToWecode"
			}, {apiName: "horizontalScreen", nativeName: "horizontalScreen"}, {
				apiName: "offHorizontalScreen",
				nativeName: "offHorizontalScreen"
			}, {
				apiName: "openBluetoothAdapter",
				nativeName: "openBluetoothAdapter",
				pcNotSupport: !0
			}, {
				apiName: "closeBluetoothAdapter",
				nativeName: "closeBluetoothAdapter",
				pcNotSupport: !0
			}, {
				apiName: "readBLECharacteristicValue",
				nativeName: "readBLECharacteristicValue",
				pcNotSupport: !0
			}, {
				apiName: "writeBLECharacteristicValue",
				nativeName: "writeBLECharacteristicValue",
				pcNotSupport: !0
			}, {
				apiName: "notifyBLECharacteristicValueChange",
				nativeName: "notifyBLECharacteristicValueChange",
				pcNotSupport: !0
			}, {
				apiName: "getBLEDeviceServices",
				nativeName: "getBLEDeviceServices",
				pcNotSupport: !0
			}, {
				apiName: "getBLEDeviceCharacteristics",
				nativeName: "getBLEDeviceCharacteristics",
				pcNotSupport: !0
			}, {
				apiName: "createBLEConnection",
				nativeName: "createBLEConnection",
				pcNotSupport: !0
			}, {
				apiName: "closeBLEConnection",
				nativeName: "closeBLEConnection",
				pcNotSupport: !0
			}, {
				apiName: "startBLEDevicesDiscovery",
				nativeName: "startBLEDevicesDiscovery",
				pcNotSupport: !0
			}, {
				apiName: "stopBLEDevicesDiscovery",
				nativeName: "stopBLEDevicesDiscovery",
				pcNotSupport: !0
			}, {
				apiName: "getConnectedBluetoothDevices",
				nativeName: "getConnectedBluetoothDevices",
				pcNotSupport: !0
			}, {
				apiName: "getBluetoothDevices",
				nativeName: "getBluetoothDevices",
				pcNotSupport: !0
			}, {
				apiName: "getBluetoothAdapterState",
				nativeName: "getBluetoothAdapterState",
				pcNotSupport: !0
			}, {
				apiName: "startBluetoothDevicesDiscovery",
				nativeName: "startBluetoothDevicesDiscovery",
				pcNotSupport: !0
			}, {
				apiName: "stopBluetoothDevicesDiscovery",
				nativeName: "stopBluetoothDevicesDiscovery",
				pcNotSupport: !0
			}, {
				apiName: "createBluetoothConnection",
				nativeName: "createBluetoothConnection",
				pcNotSupport: !0
			}, {
				apiName: "closeBluetoothConnection",
				nativeName: "closeBluetoothConnection",
				pcNotSupport: !0
			}, {
				apiName: "readBluetoothData",
				nativeName: "readBluetoothData",
				pcNotSupport: !0
			}, {
				apiName: "writeDataToBluetooth",
				nativeName: "writeDataToBluetooth",
				pcNotSupport: !0
			}, {apiName: "createBond", nativeName: "createBond", pcNotSupport: !0}]
		}, function (e, t, n) {
			var r = n(38);
			e.exports = Array.isArray || function (e) {
				return "Array" == r(e)
			}
		}, function (e, t, n) {
			var r = n(10), a = n(6), o = n(26);
			e.exports = function (e, t) {
				var n = (a.Object || {})[e] || Object[e], i = {};
				i[e] = t(n), r(r.S + r.F * o((function () {
					n(1)
				})), "Object", i)
			}
		}, function (e, t, n) {
			"use strict";
			var r = n(9), a = n(27), o = n(15), i = n(10), c = n(80), u = n(145).KEY, s = n(26), f = n(58), l = n(47),
				p = n(46), d = n(11), h = n(63), m = n(64), v = n(146), g = n(94), y = n(14), b = n(25), w = n(39),
				x = n(19), k = n(55), N = n(36), _ = n(81), S = n(147), C = n(66), O = n(49), I = n(18), j = n(37),
				E = C.f,
				L = I.f, P = S.f, H = r.Symbol, T = r.JSON, A = T && T.stringify, F = d("_hidden"),
				B = d("toPrimitive"),
				W = {}.propertyIsEnumerable, D = f("symbol-registry"), M = f("symbols"), U = f("op-symbols"),
				R = Object.prototype, J = "function" == typeof H && !!O.f, G = r.QObject,
				V = !G || !G.prototype || !G.prototype.findChild, z = o && s((function () {
					return 7 != _(L({}, "a", {
						get: function () {
							return L(this, "a", {value: 7}).a
						}
					})).a
				})) ? function (e, t, n) {
					var r = E(R, t);
					r && delete R[t], L(e, t, n), r && e !== R && L(R, t, r)
				} : L, q = function (e) {
					var t = M[e] = _(H.prototype);
					return t._k = e, t
				}, K = J && "symbol" == typeof H.iterator ? function (e) {
					return "symbol" == typeof e
				} : function (e) {
					return e instanceof H
				}, Q = function (e, t, n) {
					return e === R && Q(U, t, n), y(e), t = k(t, !0), y(n), a(M, t) ? (n.enumerable ? (a(e, F) && e[F][t] && (e[F][t] = !1), n = _(n, {enumerable: N(0, !1)})) : (a(e, F) || L(e, F, N(1, {})), e[F][t] = !0), z(e, t, n)) : L(e, t, n)
				}, $ = function (e, t) {
					y(e);
					for (var n, r = v(t = x(t)), a = 0, o = r.length; o > a;) Q(e, n = r[a++], t[n]);
					return e
				}, Y = function (e) {
					var t = W.call(this, e = k(e, !0));
					return !(this === R && a(M, e) && !a(U, e)) && (!(t || !a(this, e) || !a(M, e) || a(this, F) && this[F][e]) || t)
				}, X = function (e, t) {
					if (e = x(e), t = k(t, !0), e !== R || !a(M, t) || a(U, t)) {
						var n = E(e, t);
						return !n || !a(M, t) || a(e, F) && e[F][t] || (n.enumerable = !0), n
					}
				}, Z = function (e) {
					for (var t, n = P(x(e)), r = [], o = 0; n.length > o;) a(M, t = n[o++]) || t == F || t == u || r.push(t);
					return r
				}, ee = function (e) {
					for (var t, n = e === R, r = P(n ? U : x(e)), o = [], i = 0; r.length > i;) !a(M, t = r[i++]) || n && !a(R, t) || o.push(M[t]);
					return o
				};
			J || (c((H = function () {
				if (this instanceof H) throw TypeError("Symbol is not a constructor!");
				var e = p(arguments.length > 0 ? arguments[0] : void 0), t = function (n) {
					this === R && t.call(U, n), a(this, F) && a(this[F], e) && (this[F][e] = !1), z(this, e, N(1, n))
				};
				return o && V && z(R, e, {configurable: !0, set: t}), q(e)
			}).prototype, "toString", (function () {
				return this._k
			})), C.f = X, I.f = Q, n(65).f = S.f = Z, n(50).f = Y, O.f = ee, o && !n(34) && c(R, "propertyIsEnumerable", Y, !0), h.f = function (e) {
				return q(d(e))
			}), i(i.G + i.W + i.F * !J, {Symbol: H});
			for (var te = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), ne = 0; te.length > ne;) d(te[ne++]);
			for (var re = j(d.store), ae = 0; re.length > ae;) m(re[ae++]);
			i(i.S + i.F * !J, "Symbol", {
				for: function (e) {
					return a(D, e += "") ? D[e] : D[e] = H(e)
				}, keyFor: function (e) {
					if (!K(e)) throw TypeError(e + " is not a symbol!");
					for (var t in D) if (D[t] === e) return t
				}, useSetter: function () {
					V = !0
				}, useSimple: function () {
					V = !1
				}
			}), i(i.S + i.F * !J, "Object", {
				create: function (e, t) {
					return void 0 === t ? _(e) : $(_(e), t)
				},
				defineProperty: Q,
				defineProperties: $,
				getOwnPropertyDescriptor: X,
				getOwnPropertyNames: Z,
				getOwnPropertySymbols: ee
			});
			var oe = s((function () {
				O.f(1)
			}));
			i(i.S + i.F * oe, "Object", {
				getOwnPropertySymbols: function (e) {
					return O.f(w(e))
				}
			}), T && i(i.S + i.F * (!J || s((function () {
				var e = H();
				return "[null]" != A([e]) || "{}" != A({a: e}) || "{}" != A(Object(e))
			}))), "JSON", {
				stringify: function (e) {
					for (var t, n, r = [e], a = 1; arguments.length > a;) r.push(arguments[a++]);
					if (n = t = r[1], (b(t) || void 0 !== e) && !K(e)) return g(t) || (t = function (e, t) {
						if ("function" == typeof n && (t = n.call(this, e, t)), !K(t)) return t
					}), r[1] = t, A.apply(T, r)
				}
			}), H.prototype[B] || n(24)(H.prototype, B, H.prototype.valueOf), l(H, "Symbol"), l(Math, "Math", !0), l(r.JSON, "JSON", !0)
		}, function (e, t, n) {
			"use strict";
			var r = n(18), a = n(36);
			e.exports = function (e, t, n) {
				t in e ? r.f(e, t, a(0, n)) : e[t] = n
			}
		}, function (e, t, n) {
			e.exports = n(154)
		}, function (e, t, n) {
			var r = n(51), a = n(100);
			e.exports = function (e, t) {
				if (e) {
					if ("string" == typeof e) return a(e, t);
					var n = Object.prototype.toString.call(e).slice(8, -1);
					return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? r(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(e, t) : void 0
				}
			}
		}, function (e, t) {
			e.exports = function (e, t) {
				(null == t || t > e.length) && (t = e.length);
				for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
				return r
			}
		}, function (e, t) {
			e.exports = "\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff"
		}, function (e, t, n) {
			"use strict";
			var r = n(136), a = n(137), o = n(138);
			function i(e, t) {
				return t.encode ? t.strict ? r(e) : encodeURIComponent(e) : e
			}
			function c(e) {
				var t = e.indexOf("?");
				return -1 === t ? "" : e.slice(t + 1)
			}
			function u(e, t) {
				var n = function (e) {
					var t;
					switch (e.arrayFormat) {
						case"index":
							return function (e, n, r) {
								t = /\[(\d*)\]$/.exec(e), e = e.replace(/\[\d*\]$/, ""), t ? (void 0 === r[e] && (r[e] = {}), r[e][t[1]] = n) : r[e] = n
							};
						case"bracket":
							return function (e, n, r) {
								t = /(\[\])$/.exec(e), e = e.replace(/\[\]$/, ""), t ? void 0 !== r[e] ? r[e] = [].concat(r[e], n) : r[e] = [n] : r[e] = n
							};
						default:
							return function (e, t, n) {
								void 0 !== n[e] ? n[e] = [].concat(n[e], t) : n[e] = t
							}
					}
				}(t = a({arrayFormat: "none"}, t)), r = Object.create(null);
				return "string" != typeof e ? r : (e = e.trim().replace(/^[?#&]/, "")) ? (e.split("&").forEach((function (e) {
					var t = e.replace(/\+/g, " ").split("="), a = t.shift(), i = t.length > 0 ? t.join("=") : void 0;
					i = void 0 === i ? null : o(i), n(o(a), i, r)
				})), Object.keys(r).sort().reduce((function (e, t) {
					var n = r[t];
					return Boolean(n) && "object" == typeof n && !Array.isArray(n) ? e[t] = function e(t) {
						return Array.isArray(t) ? t.sort() : "object" == typeof t ? e(Object.keys(t)).sort((function (e, t) {
							return Number(e) - Number(t)
						})).map((function (e) {
							return t[e]
						})) : t
					}(n) : e[t] = n, e
				}), Object.create(null))) : r
			}
			t.extract = c, t.parse = u, t.stringify = function (e, t) {
				!1 === (t = a({encode: !0, strict: !0, arrayFormat: "none"}, t)).sort && (t.sort = function () {
				});
				var n = function (e) {
					switch (e.arrayFormat) {
						case"index":
							return function (t, n, r) {
								return null === n ? [i(t, e), "[", r, "]"].join("") : [i(t, e), "[", i(r, e), "]=", i(n, e)].join("")
							};
						case"bracket":
							return function (t, n) {
								return null === n ? i(t, e) : [i(t, e), "[]=", i(n, e)].join("")
							};
						default:
							return function (t, n) {
								return null === n ? i(t, e) : [i(t, e), "=", i(n, e)].join("")
							}
					}
				}(t);
				return e ? Object.keys(e).sort(t.sort).map((function (r) {
					var a = e[r];
					if (void 0 === a) return "";
					if (null === a) return i(r, t);
					if (Array.isArray(a)) {
						var o = [];
						return a.slice().forEach((function (e) {
							void 0 !== e && o.push(n(r, e, o.length))
						})), o.join("&")
					}
					return i(r, t) + "=" + i(a, t)
				})).filter((function (e) {
					return e.length > 0
				})).join("&") : ""
			}, t.parseUrl = function (e, t) {
				return {url: e.split("?")[0] || "", query: u(c(e), t)}
			}
		}, function (e, t, n) {
			var r = n(139), a = n(140);
			e.exports = function (e, t, n) {
				var o = t && n || 0;
				"string" == typeof e && (t = "binary" === e ? new Array(16) : null, e = null);
				var i = (e = e || {}).random || (e.rng || r)();
				if (i[6] = 15 & i[6] | 64, i[8] = 63 & i[8] | 128, t) for (var c = 0; c < 16; ++c) t[o + c] = i[c];
				return t || a(i)
			}
		}, function (e, t, n) {
			var r = n(69);
			e.exports = function (e, t, n) {
				return t in e ? r(e, t, {value: n, enumerable: !0, configurable: !0, writable: !0}) : e[t] = n, e
			}
		}, function (e, t, n) {
			e.exports = n(176)
		}, function (e, t, n) {
			"use strict";
			(function (e) {
				var r = n(1), a = n.n(r), o = n(3), i = n.n(o), c = n(8), u = n.n(c), s = n(2), f = n.n(s), l = n(28),
					p = n(0), d = n(31), h = n(107), m = n(42), v = n.n(m), g = n(16), y = n.n(g), b = n(12),
					w = n.n(b),
					x = n(22), k = n(7), N = n(43), _ = n(76), S = function (e) {
						return function (t) {
							return new f.a((function (n, r) {
								e(t, n, r)
							}))
						}
					}, C = {}, O = null, I = S((function (e, t, n) {
						if (e) {
							if (!O) {
								var r = document.getElementsByClassName("weui-airobot-item");
								if (!(r && r.length > 0)) {
									var a = document.createElement("div");
									a.className = "weui-airobot-item", a.onclick = function (t) {
										var n;
										t.stopPropagation(), t.preventDefault(), a.style.display = "none", (n = {
											tip: e.tip,
											needCallback: 1
										}, new f.a((function (e, t) {
											return n ? e(Object(N.b)({schema: "ui://welink.athena/bot", data: n})) : t()
										}))).then((function () {
											a.style.display = "block"
										})).catch((function () {
											a.style.display = "block"
										}))
									};
									var o = 0, i = 0;
									a.addEventListener("touchstart", (function (e) {
										var t = e.targetTouches ? e.targetTouches[0] : e;
										o = t.clientX - a.offsetLeft, i = t.clientY - a.offsetTop
									})), a.addEventListener("touchmove", (function (e) {
										e.preventDefault();
										var t = e.targetTouches ? e.targetTouches[0] : e,
											n = window.innerWidth || window.screen.width,
											r = window.innerHeight || window.screen.height, c = t.clientX - o,
											u = t.clientY - i;
										c + 48 >= n ? (a.style.right = 0, a.style.left = "auto") : (a.style.righ = "auto", a.style.left = "".concat(c < 0 ? 0 : c, "px")), u + 48 >= r ? (a.style.top = "auto", a.style.bottom = 0) : (a.style.bottom = "auto", a.style.top = "".concat(u < 0 ? 0 : u, "px"))
									})), a.insertAdjacentHTML("beforeend", '<span class="weui-airobot-item_icon"/>'), document.body.appendChild(a), O = {
										enable: function () {
											O.isShow = !0, a.style.display = "block"
										}, disable: function () {
											document.body.removeChild(a), O = null
										}
									}
								}
							}
							return O[e.operate](), void t(!0)
						}
						n({
							code: "10802",
							message: "The parameter is incorrect. Please check the documentation",
							type: "error"
						})
					}));
				C.enableAIRobot = S((function (e, t, n) {
					var r = e;
					p.o.getGlobalAppInfo().then((function (a) {
						if (!a || "zh" !== a.language) return n({status: "0", message: "暂只支持中文环境"});
						if (e && "undefined" !== e && "string" == typeof e) try {
							r = JSON.parse(e)
						} catch (e) {
							return n({
								code: "10802",
								message: "The parameter is incorrect. Please check the documentation",
								type: "error"
							})
						}
						return O && O.isShow && I({operate: "disable"}), I({
							operate: "enable",
							tip: r ? r.tip : ""
						}), t()
					}))
				})), C.disableAIRobot = function () {
					I({operate: "disable"})
				};
				var j = S((function (e, t, n) {
					var r = e;
					if (Object(p.s)("action", e, "exceptionTip", "exceptionTip"), e && "undefined" !== e) {
						if (e instanceof String) try {
							r = JSON.parse(e)
						} catch (e) {
							n(e)
						}
						var a = document, o = a.createElement("div"),
							i = "icon-big icon-big-".concat(["nodata", "nopermission", "build", "networkoutage", "pcbrower", "busysystem", "noresource"][r.flag - 1]);
						o.className = "weui-popedom-box", r.callback && o.addEventListener("click", (function () {
							r.callback()
						})), o.insertAdjacentHTML("beforeend", '<div class="con"><i class="'.concat(i, '"></i><p class="tip guide">').concat(r.msg, "</p>\n        ").concat(r.submsg ? '<p class="weui-popedom-box-subtitle">'.concat(r.submsg, "</p>") : "", "\n      </div>")), r.dom ? (o.style.position = "relative", r.dom.appendChild(o)) : a.body.appendChild(o), a.body.style.height = window.innerHeight || "".concat(window.screen.height, "px"), a.body.style.overflow = "hidden", void 0 !== r.flag && void 0 !== r.msg ? t(!0) : n(!1)
					}
				}));
				C.exceptionTip = j, C.showExceptionTip = j;
				var E = {};
				C.addEventListener = S((function (e, t, n) {
					e && "undefined" !== e && "undefined" !== e.type && "undefined" !== e.func ? (Object(p.s)("action", e, "addEventListener:".concat(e.type), "addEventListener:".concat(e.type)), E[e.type] || (E[e.type] = []), ["appLaunch", "appShow", "appHide", "close"].indexOf(e.type) >= 0 ? E[e.type] = [e.func] : E[e.type].push(e.func), HWH5.eventListener[e.type] || (HWH5.eventListener[e.type] = function (t) {
						var n;
						if (["navigationBarButtonClick", "appLaunch", "appShow", "appHide", "close"].indexOf(e.type) >= 0 && void 0 !== t && E[e.type] && E[e.type].length > 0 && E[e.type][t]) n = E[e.type][t](); else {
							var r = t;
							t && (r = l.a.decode(t));
							for (var a = 0; a < E[e.type].length && !1 !== (n = E[e.type][a](r)); a += 1) ;
						}
						return n
					}), t()) : n()
				})), C.removeEventListener = function (e) {
					var t = e.type, n = e.func;
					if (E[t]) for (var r = 0; r < E[t].length; r += 1) E[t][r] === n && E[t].splice(r, 1)
				}, C.removeEventListenerByType = function (e) {
					E[e] && (E[e] = null)
				}, C.getEventListeners = S((function (e, t, n) {
					null === e && n([]), t(E[e] || [])
				})), C.app = S((function (e, t, n) {
					if ((!e || "function" != typeof e.onLaunch && "function" != typeof e.onShow && "function" != typeof e.onHide && "function" != typeof e.onClose) && n(), Object(p.s)("action", e, "app", "app"), "function" == typeof e.onLaunch) {
						var r = {type: "appLaunch", func: e.onLaunch};
						C.addEventListener(r, t, n)
					}
					if ("function" == typeof e.onShow) {
						var a = {type: "appShow", func: e.onShow};
						C.addEventListener(a, t, n)
					}
					if ("function" == typeof e.onHide) {
						var o = {type: "appHide", func: e.onHide};
						C.addEventListener(o, t, n)
					}
					if ("function" == typeof e.onClose) {
						var i = {type: "close", func: e.onClose};
						C.addEventListener(i, t, n)
					}
				})), C.onUserCaptureScreen = S((function (e, t, n) {
					if ("function" == typeof e) {
						var r = {
							type: "userCaptureScreen", func: function () {
								return e()
							}
						};
						return C.removeEventListenerByType(r.type), void C.addEventListener(r, t, n)
					}
					n({
						code: "10802",
						message: "The parameter is incorrect. Please check the documentation",
						type: "error"
					})
				}));
				var L = function (e) {
					var t = {};
					return u()(e).forEach((function (n) {
						var r = !1;
						y.a.forEach((function (a) {
							n === a.nativeName && (t[a.apiName] = e[n], r = !0)
						})), w.a.forEach((function (a) {
							n === a.schema && (t[a.apiName] = e[n], r = !0)
						})), r || (t[n] = e[n])
					})), t
				}, P = null;
				C.canIUse = S(function () {
					var e = i()(a.a.mark((function e(t, n, r) {
						var o, i, c;
						return a.a.wrap((function (e) {
							for (; ;) switch (e.prev = e.next) {
								case 0:
									if (o = t && t.schema || [], i = {}, Object(p.s)("action", t, "canIUse", "canIUse"), P) {
										e.next = 9;
										break
									}
									return e.next = 6, HWH5.permissions(t && t.refresh).then((function (e) {
										return e
									}));
								case 6:
									(c = e.sent) && 0 !== u()(c).length || r({
										code: "NoPermission",
										message: "no permission to use jsapi",
										type: "error"
									}), P = L(c);
								case 9:
									o.forEach((function (e) {
										var t = !1;
										u()(P).forEach((function (n) {
											e === n && P[n] && (i[n] = P[n], t = !0)
										})), t || (i[e] = !1)
									})), n(i);
								case 11:
								case"end":
									return e.stop()
							}
						}), e)
					})));
					return function (t, n, r) {
						return e.apply(this, arguments)
					}
				}()), C.getBackgroundAudioManager = function (e) {
					Object(p.s)("action", e, "getBackgroundAudioManager", "getBackgroundAudioManager");
					var t = Object(d.a)();
					function n(e) {
						var n = e, r = Object(d.b)(n);
						0 !== r.status ? (n.data && n.data.cookies && (n.data.cookies = Object(p.f)(n.data.cookies)), HWH5.playAudioCustom(n).then((function () {
						})).catch((function (e) {
							t.onError && t.onError(e), console.log("playAudioCustom fail result", e)
						}))) : t.onError ? t.onError(r.msg) : console.log(r.msg)
					}
					return t.play = function () {
						n({
							action: "play",
							data: {
								url: t.url,
								startTime: t.startTime,
								background: t.background,
								repeat: t.repeat,
								playbackSpeed: t.playbackSpeed,
								cookies: t.cookies
							}
						})
					}, t.pause = function () {
						n({action: "pause"})
					}, t.stop = function () {
						n({action: "stop"})
					}, t.seek = function (e) {
						n({action: "seek", data: {position: e}})
					}, t.onAttrChange = function (e) {
						var r = t.background, a = t.repeat, o = t.playbackSpeed, i = {};
						"background" === e ? i = {
							action: "background",
							data: {background: r}
						} : "repeat" === e ? i = {
							action: "repeat",
							data: {repeat: a}
						} : "playbackSpeed" === e ? i = {
							action: "playbackSpeed",
							data: {playbackSpeed: o}
						} : t.play(), "url" !== e && n(i)
					}, t
				}, C.openLocation = function (e) {
					var t = "https://static.hc-cdn.com/map/openlocation.html?".concat(Object(p.B)(e));
					HWH5.openWebview({uri: t})
				}, C.onNetworkStatusChange = S((function (e, t, n) {
					if ("function" == typeof e) {
						HWH5.registerNetworkListener();
						var r = {
							type: "onNetworkStatusChange", func: function (t) {
								var n = {};
								try {
									n = JSON.parse(t)
								} catch (e) {
									n = t
								}
								return e(n)
							}
						};
						return C.removeEventListenerByType(r.type), void C.addEventListener(r, t, n).then((function () {
							t({status: 1})
						}))
					}
					n({
						code: "10802",
						message: "The parameter is incorrect. Please check the documentation",
						type: "error"
					})
				}));
				var H = !1;
				C.setWatermark = S((function (e, t) {
					function n(e) {
						var t, n, r, a = {
							watermark_txt: e,
							watermark_color: "#999999",
							watermark_alpha: .2,
							watermark_x_space: 130,
							watermark_y_space: 150,
							watermark_angle: 8,
							watermark_fontsize: "12px",
							watermark_width: (t = e, r = document.createElement("span"), r.innerText = t, r.className = "HWH5-getTextWidth", document.querySelector("body").appendChild(r), n = document.querySelector(".HWH5-getTextWidth").offsetWidth, document.querySelector(".HWH5-getTextWidth").remove(), n),
							watermark_height: 16,
							watermark_cols: 10,
							watermark_rows: 15
						};
						_.a.load(a), H = !0
					}
					if (e && "string" == typeof e) return n(e), void t({status: "1", statusCode: "1"});
					p.p.getGlobalUserInfo().then((function () {
						k.c.userInfo;
						n(""), t({status: "1", statusCode: "1"})
					}))
				})), C.removeWatermark = function () {
					H && (_.a.remove(), H = !1)
				};
				var T = {};
				function A(e, t, n) {
					var r = {code: "", msg: ""};
					HWH5.encryptFile({
						filePath: e.filePath,
						etype: e.encryptEtype,
						common_internal_call: !0
					}).then((function (e) {
						t(e)
					})).catch((function () {
						r.code = "10903", r.msg = "encryptFile fail", HWH5.removeFile({
							path: e.filePath,
							etype: e.deleteEtype,
							common_internal_call: !0
						}).catch((function (t) {
							console.log("common encryptFile fail remove fail ", t), HWH5.removeFile({
								path: e.filePath,
								common_internal_call: !0
							}), HWH5.removeFile({
								path: e.filePath,
								common_internal_call: !0
							}), HWH5.removeFile({path: e.filePath, common_internal_call: !0})
						})), n(r)
					}))
				}
				C.onBluetoothEvents = S((function (e, t) {
					var n = {
						type: "onBluetoothEvents", func: function (e) {
							var n = {};
							try {
								n = JSON.parse(e)
							} catch (e) {
								t(e)
							}
							n.type && T[n.type] ? ("CB_BVC" !== n.type && "BLE_CVC" !== n.type || !n.data.value || (n.data.value = Object(p.b)(n.data.value)), "BT_DF" === n.type && n.data && n.data.devices && n.data.devices.length > 0 && n.data.devices.forEach((function (e, t) {
								var r = e;
								if (r.advertisData) {
									try {
										r.advertisData = Object(p.b)(r.advertisData)
									} catch (t) {
										console.log('common parse "advertisData" fail', t, e.advertisData)
									}
									n.data.devices[t] = r
								}
								r.serviceData && (r.serviceData = Object(p.z)(r.serviceData))
							})), T[n.type](n.data)) : t("callBack onBluetoothEvents type error")
						}
					};
					C.removeEventListenerByType(n.type), C.addEventListener(n, e, t)
				})), C.onBLECharacteristicValueChange = function (e) {
					T.BLE_CVC = e
				}, C.onBLEConnectionStateChange = function (e) {
					T.BLE_CSC = e
				}, C.onBluetoothAdapterStateChange = function (e) {
					T.BT_ASC = e
				}, C.onBluetoothDeviceFound = function (e) {
					T.BT_DF = e
				}, C.onBluetoothConnectionStateChange = function (e) {
					T.CB_CSC = e
				}, C.onBluetoothValueChange = function (e) {
					T.CB_BVC = e
				}, C.onBondStateChange = function (e) {
					T.CB_BSC = e
				}, C.enableValidateParameter = function (e) {
					x.b.enable(e)
				}, C.downloadFileAndEncrypt = S((function (e, t, n) {
					HWH5.downloadFile(e).then((function () {
						A(e, t, n)
					})).catch((function (e) {
						n(e)
					}))
				})), C.downloadEDMAndEncrypt = S((function (e, t, n) {
					HWH5.downloadToMDM(e).then((function () {
						A(e, t, n)
					})).catch((function (e) {
						n(e)
					}))
				})), C.downloadFileVPNAndEncrypt = S((function (e, t, n) {
					HWH5.downloadFileVPN(e).then((function () {
						A(e, t, n)
					})).catch((function (e) {
						n(e)
					}))
				})), C.getUpdateManager = i()(a.a.mark((function t() {
					var n, r;
					return a.a.wrap((function (t) {
						for (; ;) switch (t.prev = t.next) {
							case 0:
								return t.next = 2, Object(p.n)(1);
							case 2:
								if (n = t.sent, r = {}, !n || "-1" !== n.status) {
									t.next = 7;
									break
								}
								return e.alert("We码已下线"), t.abrupt("return", r);
							case 7:
								return r.onCheckForUpdate = function () {
									var e = i()(a.a.mark((function e(t) {
										var r, o;
										return a.a.wrap((function (e) {
											for (; ;) switch (e.prev = e.next) {
												case 0:
													if (!n || "2" !== n.status) {
														e.next = 3;
														break
													}
													return t({hasUpdate: "1"}), e.abrupt("return");
												case 3:
													r = 0, o = setInterval(i()(a.a.mark((function e() {
														return a.a.wrap((function (e) {
															for (; ;) switch (e.prev = e.next) {
																case 0:
																	return r += 1, e.next = 3, Object(p.n)(1);
																case 3:
																	(n = e.sent) && "2" === n.status && (t({hasUpdate: "1"}), clearInterval(o)), 2 === r && clearInterval(o);
																case 6:
																case"end":
																	return e.stop()
															}
														}), e)
													}))), 3e3);
												case 5:
												case"end":
													return e.stop()
											}
										}), e)
									})));
									return function (t) {
										return e.apply(this, arguments)
									}
								}(), t.abrupt("return", r);
							case 9:
							case"end":
								return t.stop()
						}
					}), t)
				}))), C.makeSchemaAPI = S((function (e, t, n) {
					var r = e.apiName, a = e.schema, o = {code: "", msg: "", status: ""};
					return r && a && "string" == typeof r && "string" == typeof a ? HWH5[r] ? (o.code = "30802", o.msg = "Api has already been declared", o.status = "0", o.statusCode = "0", void n(o)) : (Object(N.a)(r, a), void t({
						status: "1",
						statusCode: "1"
					})) : (o.code = "10802", o.msg = "Parameter error", o.status = "0", o.statusCode = "0", void n(o))
				})), C.setNavigationCallBacks = function (e) {
					var t = {
						type: "wecode_navigation_call_backs", common_internal_call: !0, func: function (t) {
							e[t] && e[t]()
						}
					};
					C.removeEventListenerByType(t.type), C.addEventListener(t, p.h, p.h)
				}, C.getRealtimeLogManager = function () {
					return new h.a
				}, C.__getBuildTimestamp = function () {
					return {timestamp: "2020-12-29 17:53:23"}
				};
				t.a = function () {
					for (var e = 0; e < v.a.length; e += 1) {
						var t = v.a[e].apiName;
						HWH5[t] = C[t]
					}
					HWH5.eventListener = []
				}
			}).call(this, n(40))
		}, function (e, t, n) {
			"use strict";
			(function (e) {
				n.d(t, "a", (function () {
					return h
				}));
				var r = n(1), a = n.n(r), o = n(4), i = n.n(o), c = n(21), u = n.n(c), s = n(3), f = n.n(s), l = n(0),
					p = n(108), d = Object(p.a)(5, 1e3);
				function h() {
					var t = {
						eventId: "WECODE_REALTIME_LOG",
						eventLabel: "We码实时日志",
						extendData: {appId: "", type: "", filterMsg: "", logLevel: "", logContent: "", page: ""}
					};
					function n(e) {
						return !(!e || "string" != typeof e) || (console.warn("params must be string"), !1)
					}
					function r() {
						return e.location.href ? e.location.href.substr(e.location.href.indexOf("apps/"), e.location.href.length) : ""
					}
					function o(e) {
						d(f()(a.a.mark((function n() {
							var r, o, c;
							return a.a.wrap((function (n) {
								for (; ;) switch (n.prev = n.next) {
									case 0:
										return r = e, n.next = 3, Object(l.n)();
									case 3:
										o = n.sent, r.appId = o.appId, r.type = Object(l.m)(o.appId), (c = u()({}, t, {extendData: r})).extendData = i()(c.extendData), Object(l.t)(c);
									case 9:
									case"end":
										return n.stop()
								}
							}), n)
						}))))
					}
					return this.info = function (e) {
						n(e) && o({logLevel: "info", logContent: e, page: r(), filterMsg: t.extendData.filterMsg})
					}, this.warn = function (e) {
						n(e) && o({logLevel: "warn", logContent: e, page: r(), filterMsg: t.extendData.filterMsg})
					}, this.error = function (e) {
						n(e) && o({logLevel: "error", logContent: e, page: r(), filterMsg: t.extendData.filterMsg})
					}, this.setFilterMsg = function (e) {
						t.extendData.filterMsg = e && "string" == typeof e ? e : ""
					}, this.addFilterMsg = function (e) {
						n(e) && (t.extendData.filterMsg = "".concat(t.extendData.filterMsg, " ").concat(e))
					}, this
				}
			}).call(this, n(40))
		}, function (e, t, n) {
			"use strict";
			(function (e) {
				var r, a = n(20), o = n.n(a), i = n(17), c = n.n(i),
					u = "object" === ("undefined" == typeof self ? "undefined" : c()(self)) && self.self === self && self || "object" === (void 0 === e ? "undefined" : c()(e)) && e.global === e && e || void 0;
				null != u && (r = u.throttledQueue);
				var s = function (e, t, n) {
					n && (t /= e, e = 1), t < 200 && console.warn("An interval of less than 200ms can create performance issues.");
					var r, a = [], i = o()(), c = function n() {
						var c = i + t, u = o()();
						if (u < c) return clearTimeout(r), void (r = setTimeout(n, c - u));
						for (var s = a.splice(0, e), f = 0; f < s.length; f++) s[f]();
						i = o()(), r = a.length ? setTimeout(n, t) : null
					};
					return function (e) {
						a.push(e), r || (r = setTimeout(c, t))
					}
				};
				s.noConflict = function () {
					return u.throttledQueue = r, s
				}, t.a = s
			}).call(this, n(40))
		}, function (e, t, n) {
			n(77), n(33), n(48), n(118), n(126), n(127), e.exports = n(6).Promise
		}, function (e, t, n) {
			var r = n(53), a = n(44);
			e.exports = function (e) {
				return function (t, n) {
					var o, i, c = String(a(t)), u = r(n), s = c.length;
					return u < 0 || u >= s ? e ? "" : void 0 : (o = c.charCodeAt(u)) < 55296 || o > 56319 || u + 1 === s || (i = c.charCodeAt(u + 1)) < 56320 || i > 57343 ? e ? c.charAt(u) : o : e ? c.slice(u, u + 2) : i - 56320 + (o - 55296 << 10) + 65536
				}
			}
		}, function (e, t, n) {
			"use strict";
			var r = n(81), a = n(36), o = n(47), i = {};
			n(24)(i, n(11)("iterator"), (function () {
				return this
			})), e.exports = function (e, t, n) {
				e.prototype = r(i, {next: a(1, n)}), o(e, t + " Iterator")
			}
		}, function (e, t, n) {
			var r = n(19), a = n(56), o = n(113);
			e.exports = function (e) {
				return function (t, n, i) {
					var c, u = r(t), s = a(u.length), f = o(i, s);
					if (e && n != n) {
						for (; s > f;) if ((c = u[f++]) != c) return !0
					} else for (; s > f; f++) if ((e || f in u) && u[f] === n) return e || f || 0;
					return !e && -1
				}
			}
		}, function (e, t, n) {
			var r = n(53), a = Math.max, o = Math.min;
			e.exports = function (e, t) {
				return (e = r(e)) < 0 ? a(e + t, 0) : o(e, t)
			}
		}, function (e, t, n) {
			var r = n(27), a = n(39), o = n(57)("IE_PROTO"), i = Object.prototype;
			e.exports = Object.getPrototypeOf || function (e) {
				return e = a(e), r(e, o) ? e[o] : "function" == typeof e.constructor && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? i : null
			}
		}, function (e, t, n) {
			"use strict";
			var r = n(116), a = n(117), o = n(30), i = n(19);
			e.exports = n(78)(Array, "Array", (function (e, t) {
				this._t = i(e), this._i = 0, this._k = t
			}), (function () {
				var e = this._t, t = this._k, n = this._i++;
				return !e || n >= e.length ? (this._t = void 0, a(1)) : a(0, "keys" == t ? n : "values" == t ? e[n] : [n, e[n]])
			}), "values"), o.Arguments = o.Array, r("keys"), r("values"), r("entries")
		}, function (e, t) {
			e.exports = function () {
			}
		}, function (e, t) {
			e.exports = function (e, t) {
				return {value: t, done: !!e}
			}
		}, function (e, t, n) {
			"use strict";
			var r, a, o, i, c = n(34), u = n(9), s = n(35), f = n(60), l = n(10), p = n(25), d = n(45), h = n(119),
				m = n(120), v = n(88), g = n(89).set, y = n(122)(), b = n(62), w = n(90), x = n(123), k = n(91),
				N = u.TypeError, _ = u.process, S = _ && _.versions, C = S && S.v8 || "", O = u.Promise,
				I = "process" == f(_), j = function () {
				}, E = a = b.f, L = !!function () {
					try {
						var e = O.resolve(1), t = (e.constructor = {})[n(11)("species")] = function (e) {
							e(j, j)
						};
						return (I || "function" == typeof PromiseRejectionEvent) && e.then(j) instanceof t && 0 !== C.indexOf("6.6") && -1 === x.indexOf("Chrome/66")
					} catch (e) {
					}
				}(), P = function (e) {
					var t;
					return !(!p(e) || "function" != typeof (t = e.then)) && t
				}, H = function (e, t) {
					if (!e._n) {
						e._n = !0;
						var n = e._c;
						y((function () {
							for (var r = e._v, a = 1 == e._s, o = 0, i = function (t) {
								var n, o, i, c = a ? t.ok : t.fail, u = t.resolve, s = t.reject, f = t.domain;
								try {
									c ? (a || (2 == e._h && F(e), e._h = 1), !0 === c ? n = r : (f && f.enter(), n = c(r), f && (f.exit(), i = !0)), n === t.promise ? s(N("Promise-chain cycle")) : (o = P(n)) ? o.call(n, u, s) : u(n)) : s(r)
								} catch (e) {
									f && !i && f.exit(), s(e)
								}
							}; n.length > o;) i(n[o++]);
							e._c = [], e._n = !1, t && !e._h && T(e)
						}))
					}
				}, T = function (e) {
					g.call(u, (function () {
						var t, n, r, a = e._v, o = A(e);
						if (o && (t = w((function () {
							I ? _.emit("unhandledRejection", a, e) : (n = u.onunhandledrejection) ? n({
								promise: e,
								reason: a
							}) : (r = u.console) && r.error && r.error("Unhandled promise rejection", a)
						})), e._h = I || A(e) ? 2 : 1), e._a = void 0, o && t.e) throw t.v
					}))
				}, A = function (e) {
					return 1 !== e._h && 0 === (e._a || e._c).length
				}, F = function (e) {
					g.call(u, (function () {
						var t;
						I ? _.emit("rejectionHandled", e) : (t = u.onrejectionhandled) && t({promise: e, reason: e._v})
					}))
				}, B = function (e) {
					var t = this;
					t._d || (t._d = !0, (t = t._w || t)._v = e, t._s = 2, t._a || (t._a = t._c.slice()), H(t, !0))
				}, W = function (e) {
					var t, n = this;
					if (!n._d) {
						n._d = !0, n = n._w || n;
						try {
							if (n === e) throw N("Promise can't be resolved itself");
							(t = P(e)) ? y((function () {
								var r = {_w: n, _d: !1};
								try {
									t.call(e, s(W, r, 1), s(B, r, 1))
								} catch (e) {
									B.call(r, e)
								}
							})) : (n._v = e, n._s = 1, H(n, !1))
						} catch (e) {
							B.call({_w: n, _d: !1}, e)
						}
					}
				};
			L || (O = function (e) {
				h(this, O, "Promise", "_h"), d(e), r.call(this);
				try {
					e(s(W, this, 1), s(B, this, 1))
				} catch (e) {
					B.call(this, e)
				}
			}, (r = function (e) {
				this._c = [], this._a = void 0, this._s = 0, this._d = !1, this._v = void 0, this._h = 0, this._n = !1
			}).prototype = n(124)(O.prototype, {
				then: function (e, t) {
					var n = E(v(this, O));
					return n.ok = "function" != typeof e || e, n.fail = "function" == typeof t && t, n.domain = I ? _.domain : void 0, this._c.push(n), this._a && this._a.push(n), this._s && H(this, !1), n.promise
				}, catch: function (e) {
					return this.then(void 0, e)
				}
			}), o = function () {
				var e = new r;
				this.promise = e, this.resolve = s(W, e, 1), this.reject = s(B, e, 1)
			}, b.f = E = function (e) {
				return e === O || e === i ? new o(e) : a(e)
			}), l(l.G + l.W + l.F * !L, {Promise: O}), n(47)(O, "Promise"), n(125)("Promise"), i = n(6).Promise, l(l.S + l.F * !L, "Promise", {
				reject: function (e) {
					var t = E(this);
					return (0, t.reject)(e), t.promise
				}
			}), l(l.S + l.F * (c || !L), "Promise", {
				resolve: function (e) {
					return k(c && this === i ? O : this, e)
				}
			}), l(l.S + l.F * !(L && n(92)((function (e) {
				O.all(e).catch(j)
			}))), "Promise", {
				all: function (e) {
					var t = this, n = E(t), r = n.resolve, a = n.reject, o = w((function () {
						var n = [], o = 0, i = 1;
						m(e, !1, (function (e) {
							var c = o++, u = !1;
							n.push(void 0), i++, t.resolve(e).then((function (e) {
								u || (u = !0, n[c] = e, --i || r(n))
							}), a)
						})), --i || r(n)
					}));
					return o.e && a(o.v), n.promise
				}, race: function (e) {
					var t = this, n = E(t), r = n.reject, a = w((function () {
						m(e, !1, (function (e) {
							t.resolve(e).then(n.resolve, r)
						}))
					}));
					return a.e && r(a.v), n.promise
				}
			})
		}, function (e, t) {
			e.exports = function (e, t, n, r) {
				if (!(e instanceof t) || void 0 !== r && r in e) throw TypeError(n + ": incorrect invocation!");
				return e
			}
		}, function (e, t, n) {
			var r = n(35), a = n(86), o = n(87), i = n(14), c = n(56), u = n(61), s = {}, f = {};
			(t = e.exports = function (e, t, n, l, p) {
				var d, h, m, v, g = p ? function () {
					return e
				} : u(e), y = r(n, l, t ? 2 : 1), b = 0;
				if ("function" != typeof g) throw TypeError(e + " is not iterable!");
				if (o(g)) {
					for (d = c(e.length); d > b; b++) if ((v = t ? y(i(h = e[b])[0], h[1]) : y(e[b])) === s || v === f) return v
				} else for (m = g.call(e); !(h = m.next()).done;) if ((v = a(m, y, h.value, t)) === s || v === f) return v
			}).BREAK = s, t.RETURN = f
		}, function (e, t) {
			e.exports = function (e, t, n) {
				var r = void 0 === n;
				switch (t.length) {
					case 0:
						return r ? e() : e.call(n);
					case 1:
						return r ? e(t[0]) : e.call(n, t[0]);
					case 2:
						return r ? e(t[0], t[1]) : e.call(n, t[0], t[1]);
					case 3:
						return r ? e(t[0], t[1], t[2]) : e.call(n, t[0], t[1], t[2]);
					case 4:
						return r ? e(t[0], t[1], t[2], t[3]) : e.call(n, t[0], t[1], t[2], t[3])
				}
				return e.apply(n, t)
			}
		}, function (e, t, n) {
			var r = n(9), a = n(89).set, o = r.MutationObserver || r.WebKitMutationObserver, i = r.process,
				c = r.Promise,
				u = "process" == n(38)(i);
			e.exports = function () {
				var e, t, n, s = function () {
					var r, a;
					for (u && (r = i.domain) && r.exit(); e;) {
						a = e.fn, e = e.next;
						try {
							a()
						} catch (r) {
							throw e ? n() : t = void 0, r
						}
					}
					t = void 0, r && r.enter()
				};
				if (u) n = function () {
					i.nextTick(s)
				}; else if (!o || r.navigator && r.navigator.standalone) if (c && c.resolve) {
					var f = c.resolve(void 0);
					n = function () {
						f.then(s)
					}
				} else n = function () {
					a.call(r, s)
				}; else {
					var l = !0, p = document.createTextNode("");
					new o(s).observe(p, {characterData: !0}), n = function () {
						p.data = l = !l
					}
				}
				return function (r) {
					var a = {fn: r, next: void 0};
					t && (t.next = a), e || (e = a, n()), t = a
				}
			}
		}, function (e, t, n) {
			var r = n(9).navigator;
			e.exports = r && r.userAgent || ""
		}, function (e, t, n) {
			var r = n(24);
			e.exports = function (e, t, n) {
				for (var a in t) n && e[a] ? e[a] = t[a] : r(e, a, t[a]);
				return e
			}
		}, function (e, t, n) {
			"use strict";
			var r = n(9), a = n(6), o = n(18), i = n(15), c = n(11)("species");
			e.exports = function (e) {
				var t = "function" == typeof a[e] ? a[e] : r[e];
				i && t && !t[c] && o.f(t, c, {
					configurable: !0, get: function () {
						return this
					}
				})
			}
		}, function (e, t, n) {
			"use strict";
			var r = n(10), a = n(6), o = n(9), i = n(88), c = n(91);
			r(r.P + r.R, "Promise", {
				finally: function (e) {
					var t = i(this, a.Promise || o.Promise), n = "function" == typeof e;
					return this.then(n ? function (n) {
						return c(t, e()).then((function () {
							return n
						}))
					} : e, n ? function (n) {
						return c(t, e()).then((function () {
							throw n
						}))
					} : e)
				}
			})
		}, function (e, t, n) {
			"use strict";
			var r = n(10), a = n(62), o = n(90);
			r(r.S, "Promise", {
				try: function (e) {
					var t = a.f(this), n = o(e);
					return (n.e ? t.reject : t.resolve)(n.v), t.promise
				}
			})
		}, function (e, t) {
			e.exports = [{
				apiName: "openUserProfile",
				schema: "ui://welink.contacts/userDetailController"
			}, {apiName: "createIMGroupChat", schema: "ui://welink.im/imCreateGroupChat"}, {
				apiName: "selectContacts",
				schema: "ui://welink.contacts/usersSelectorController"
			}, {apiName: "openIMChat", schema: "ui://welink.im/gotoChatController"}, {
				apiName: "writeMail",
				schema: "ui://welink.mail/writemail"
			}, {apiName: "openWebview", schema: ""}, {
				apiName: "getIMGroupList",
				schema: "method://welink.im/getGroupDetailList"
			}, {apiName: "makePhoneCall", schema: "method://welink.im/makingCall"}, {
				apiName: "selectUsers",
				schema: "ui://welink.contacts/usersSelectorControllerV2"
			}, {apiName: "startMeeting", schema: "ui://welink.conference/startConf"}]
		}, function (e, t) {
			e.exports = [{apiName: "addEventListener"}, {apiName: "removeEventListener"}, {apiName: "removeEventListenerByType"}, {apiName: "getEventListeners"}, {apiName: "ready"}, {apiName: "error"}, {apiName: "onBLECharacteristicValueChange"}, {apiName: "onBLEConnectionStateChange"}, {apiName: "onBluetoothAdapterStateChange"}, {apiName: "onBluetoothDeviceFound"}, {apiName: "onBluetoothConnectionStateChange"}, {apiName: "onBluetoothValueChange"}, {apiName: "onBondStateChange"}, {apiName: "onBluetoothEvents"}]
		}, function (e, t, n) {
			var r = function (e) {
				"use strict";
				var t = Object.prototype, n = t.hasOwnProperty, r = "function" == typeof Symbol ? Symbol : {},
					a = r.iterator || "@@iterator", o = r.asyncIterator || "@@asyncIterator",
					i = r.toStringTag || "@@toStringTag";
				function c(e, t, n, r) {
					var a = t && t.prototype instanceof f ? t : f, o = Object.create(a.prototype), i = new k(r || []);
					return o._invoke = function (e, t, n) {
						var r = "suspendedStart";
						return function (a, o) {
							if ("executing" === r) throw new Error("Generator is already running");
							if ("completed" === r) {
								if ("throw" === a) throw o;
								return _()
							}
							for (n.method = a, n.arg = o; ;) {
								var i = n.delegate;
								if (i) {
									var c = b(i, n);
									if (c) {
										if (c === s) continue;
										return c
									}
								}
								if ("next" === n.method) n.sent = n._sent = n.arg; else if ("throw" === n.method) {
									if ("suspendedStart" === r) throw r = "completed", n.arg;
									n.dispatchException(n.arg)
								} else "return" === n.method && n.abrupt("return", n.arg);
								r = "executing";
								var f = u(e, t, n);
								if ("normal" === f.type) {
									if (r = n.done ? "completed" : "suspendedYield", f.arg === s) continue;
									return {value: f.arg, done: n.done}
								}
								"throw" === f.type && (r = "completed", n.method = "throw", n.arg = f.arg)
							}
						}
					}(e, n, i), o
				}
				function u(e, t, n) {
					try {
						return {type: "normal", arg: e.call(t, n)}
					} catch (e) {
						return {type: "throw", arg: e}
					}
				}
				e.wrap = c;
				var s = {};
				function f() {
				}
				function l() {
				}
				function p() {
				}
				var d = {};
				d[a] = function () {
					return this
				};
				var h = Object.getPrototypeOf, m = h && h(h(N([])));
				m && m !== t && n.call(m, a) && (d = m);
				var v = p.prototype = f.prototype = Object.create(d);
				function g(e) {
					["next", "throw", "return"].forEach((function (t) {
						e[t] = function (e) {
							return this._invoke(t, e)
						}
					}))
				}
				function y(e, t) {
					var r;
					this._invoke = function (a, o) {
						function i() {
							return new t((function (r, i) {
								!function r(a, o, i, c) {
									var s = u(e[a], e, o);
									if ("throw" !== s.type) {
										var f = s.arg, l = f.value;
										return l && "object" == typeof l && n.call(l, "__await") ? t.resolve(l.__await).then((function (e) {
											r("next", e, i, c)
										}), (function (e) {
											r("throw", e, i, c)
										})) : t.resolve(l).then((function (e) {
											f.value = e, i(f)
										}), (function (e) {
											return r("throw", e, i, c)
										}))
									}
									c(s.arg)
								}(a, o, r, i)
							}))
						}
						return r = r ? r.then(i, i) : i()
					}
				}
				function b(e, t) {
					var n = e.iterator[t.method];
					if (void 0 === n) {
						if (t.delegate = null, "throw" === t.method) {
							if (e.iterator.return && (t.method = "return", t.arg = void 0, b(e, t), "throw" === t.method)) return s;
							t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method")
						}
						return s
					}
					var r = u(n, e.iterator, t.arg);
					if ("throw" === r.type) return t.method = "throw", t.arg = r.arg, t.delegate = null, s;
					var a = r.arg;
					return a ? a.done ? (t[e.resultName] = a.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, s) : a : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, s)
				}
				function w(e) {
					var t = {tryLoc: e[0]};
					1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t)
				}
				function x(e) {
					var t = e.completion || {};
					t.type = "normal", delete t.arg, e.completion = t
				}
				function k(e) {
					this.tryEntries = [{tryLoc: "root"}], e.forEach(w, this), this.reset(!0)
				}
				function N(e) {
					if (e) {
						var t = e[a];
						if (t) return t.call(e);
						if ("function" == typeof e.next) return e;
						if (!isNaN(e.length)) {
							var r = -1, o = function t() {
								for (; ++r < e.length;) if (n.call(e, r)) return t.value = e[r], t.done = !1, t;
								return t.value = void 0, t.done = !0, t
							};
							return o.next = o
						}
					}
					return {next: _}
				}
				function _() {
					return {value: void 0, done: !0}
				}
				return l.prototype = v.constructor = p, p.constructor = l, p[i] = l.displayName = "GeneratorFunction", e.isGeneratorFunction = function (e) {
					var t = "function" == typeof e && e.constructor;
					return !!t && (t === l || "GeneratorFunction" === (t.displayName || t.name))
				}, e.mark = function (e) {
					return Object.setPrototypeOf ? Object.setPrototypeOf(e, p) : (e.__proto__ = p, i in e || (e[i] = "GeneratorFunction")), e.prototype = Object.create(v), e
				}, e.awrap = function (e) {
					return {__await: e}
				}, g(y.prototype), y.prototype[o] = function () {
					return this
				}, e.AsyncIterator = y, e.async = function (t, n, r, a, o) {
					void 0 === o && (o = Promise);
					var i = new y(c(t, n, r, a), o);
					return e.isGeneratorFunction(n) ? i : i.next().then((function (e) {
						return e.done ? e.value : i.next()
					}))
				}, g(v), v[i] = "Generator", v[a] = function () {
					return this
				}, v.toString = function () {
					return "[object Generator]"
				}, e.keys = function (e) {
					var t = [];
					for (var n in e) t.push(n);
					return t.reverse(), function n() {
						for (; t.length;) {
							var r = t.pop();
							if (r in e) return n.value = r, n.done = !1, n
						}
						return n.done = !0, n
					}
				}, e.values = N, k.prototype = {
					constructor: k, reset: function (e) {
						if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(x), !e) for (var t in this) "t" === t.charAt(0) && n.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0)
					}, stop: function () {
						this.done = !0;
						var e = this.tryEntries[0].completion;
						if ("throw" === e.type) throw e.arg;
						return this.rval
					}, dispatchException: function (e) {
						if (this.done) throw e;
						var t = this;
						function r(n, r) {
							return i.type = "throw", i.arg = e, t.next = n, r && (t.method = "next", t.arg = void 0), !!r
						}
						for (var a = this.tryEntries.length - 1; a >= 0; --a) {
							var o = this.tryEntries[a], i = o.completion;
							if ("root" === o.tryLoc) return r("end");
							if (o.tryLoc <= this.prev) {
								var c = n.call(o, "catchLoc"), u = n.call(o, "finallyLoc");
								if (c && u) {
									if (this.prev < o.catchLoc) return r(o.catchLoc, !0);
									if (this.prev < o.finallyLoc) return r(o.finallyLoc)
								} else if (c) {
									if (this.prev < o.catchLoc) return r(o.catchLoc, !0)
								} else {
									if (!u) throw new Error("try statement without catch or finally");
									if (this.prev < o.finallyLoc) return r(o.finallyLoc)
								}
							}
						}
					}, abrupt: function (e, t) {
						for (var r = this.tryEntries.length - 1; r >= 0; --r) {
							var a = this.tryEntries[r];
							if (a.tryLoc <= this.prev && n.call(a, "finallyLoc") && this.prev < a.finallyLoc) {
								var o = a;
								break
							}
						}
						o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
						var i = o ? o.completion : {};
						return i.type = e, i.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, s) : this.complete(i)
					}, complete: function (e, t) {
						if ("throw" === e.type) throw e.arg;
						return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), s
					}, finish: function (e) {
						for (var t = this.tryEntries.length - 1; t >= 0; --t) {
							var n = this.tryEntries[t];
							if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), x(n), s
						}
					}, catch: function (e) {
						for (var t = this.tryEntries.length - 1; t >= 0; --t) {
							var n = this.tryEntries[t];
							if (n.tryLoc === e) {
								var r = n.completion;
								if ("throw" === r.type) {
									var a = r.arg;
									x(n)
								}
								return a
							}
						}
						throw new Error("illegal catch attempt")
					}, delegateYield: function (e, t, n) {
						return this.delegate = {
							iterator: N(e),
							resultName: t,
							nextLoc: n
						}, "next" === this.method && (this.arg = void 0), s
					}
				}, e
			}(e.exports);
			try {
				regeneratorRuntime = r
			} catch (e) {
				Function("r", "regeneratorRuntime = r")(r)
			}
		}, function (e, t, n) {
			n(132), e.exports = n(6).Array.isArray
		}, function (e, t, n) {
			var r = n(10);
			r(r.S, "Array", {isArray: n(94)})
		}, function (e, t, n) {
			n(134), e.exports = n(6).Object.keys
		}, function (e, t, n) {
			var r = n(39), a = n(37);
			n(95)("keys", (function () {
				return function (e) {
					return a(r(e))
				}
			}))
		}, function (e, t, n) {
			var r = n(6), a = r.JSON || (r.JSON = {stringify: JSON.stringify});
			e.exports = function (e) {
				return a.stringify.apply(a, arguments)
			}
		}, function (e, t, n) {
			"use strict";
			e.exports = function (e) {
				return encodeURIComponent(e).replace(/[!'()*]/g, (function (e) {
					return "%" + e.charCodeAt(0).toString(16).toUpperCase()
				}))
			}
		}, function (e, t, n) {
			"use strict";
			/*
    object-assign
    (c) Sindre Sorhus
    @license MIT
    */
			var r = Object.getOwnPropertySymbols, a = Object.prototype.hasOwnProperty,
				o = Object.prototype.propertyIsEnumerable;
			function i(e) {
				if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
				return Object(e)
			}
			e.exports = function () {
				try {
					if (!Object.assign) return !1;
					var e = new String("abc");
					if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;
					for (var t = {}, n = 0; n < 10; n++) t["_" + String.fromCharCode(n)] = n;
					if ("0123456789" !== Object.getOwnPropertyNames(t).map((function (e) {
						return t[e]
					})).join("")) return !1;
					var r = {};
					return "abcdefghijklmnopqrst".split("").forEach((function (e) {
						r[e] = e
					})), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("")
				} catch (e) {
					return !1
				}
			}() ? Object.assign : function (e, t) {
				for (var n, c, u = i(e), s = 1; s < arguments.length; s++) {
					for (var f in n = Object(arguments[s])) a.call(n, f) && (u[f] = n[f]);
					if (r) {
						c = r(n);
						for (var l = 0; l < c.length; l++) o.call(n, c[l]) && (u[c[l]] = n[c[l]])
					}
				}
				return u
			}
		}, function (e, t, n) {
			"use strict";
			var r = new RegExp("%[a-f0-9]{2}", "gi"), a = new RegExp("(%[a-f0-9]{2})+", "gi");
			function o(e, t) {
				try {
					return decodeURIComponent(e.join(""))
				} catch (e) {
				}
				if (1 === e.length) return e;
				t = t || 1;
				var n = e.slice(0, t), r = e.slice(t);
				return Array.prototype.concat.call([], o(n), o(r))
			}
			function i(e) {
				try {
					return decodeURIComponent(e)
				} catch (a) {
					for (var t = e.match(r), n = 1; n < t.length; n++) t = (e = o(t, n).join("")).match(r);
					return e
				}
			}
			e.exports = function (e) {
				if ("string" != typeof e) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");
				try {
					return e = e.replace(/\+/g, " "), decodeURIComponent(e)
				} catch (t) {
					return function (e) {
						for (var t = {"%FE%FF": "��", "%FF%FE": "��"}, n = a.exec(e); n;) {
							try {
								t[n[0]] = decodeURIComponent(n[0])
							} catch (e) {
								var r = i(n[0]);
								r !== n[0] && (t[n[0]] = r)
							}
							n = a.exec(e)
						}
						t["%C2"] = "�";
						for (var o = Object.keys(t), c = 0; c < o.length; c++) {
							var u = o[c];
							e = e.replace(new RegExp(u, "g"), t[u])
						}
						return e
					}(e)
				}
			}
		}, function (e, t) {
			var n = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof window.msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto);
			if (n) {
				var r = new Uint8Array(16);
				e.exports = function () {
					return n(r), r
				}
			} else {
				var a = new Array(16);
				e.exports = function () {
					for (var e, t = 0; t < 16; t++) 0 == (3 & t) && (e = 4294967296 * Math.random()), a[t] = e >>> ((3 & t) << 3) & 255;
					return a
				}
			}
		}, function (e, t) {
			for (var n = [], r = 0; r < 256; ++r) n[r] = (r + 256).toString(16).substr(1);
			e.exports = function (e, t) {
				var r = t || 0, a = n;
				return [a[e[r++]], a[e[r++]], a[e[r++]], a[e[r++]], "-", a[e[r++]], a[e[r++]], "-", a[e[r++]], a[e[r++]], "-", a[e[r++]], a[e[r++]], "-", a[e[r++]], a[e[r++]], a[e[r++]], a[e[r++]], a[e[r++]], a[e[r++]]].join("")
			}
		}, function (e, t, n) {
			n(48), n(33), e.exports = n(142)
		}, function (e, t, n) {
			var r = n(14), a = n(61);
			e.exports = n(6).getIterator = function (e) {
				var t = a(e);
				if ("function" != typeof t) throw TypeError(e + " is not iterable!");
				return r(t.call(e))
			}
		}, function (e, t, n) {
			n(33), n(48), e.exports = n(63).f("iterator")
		}, function (e, t, n) {
			n(96), n(77), n(148), n(149), e.exports = n(6).Symbol
		}, function (e, t, n) {
			var r = n(46)("meta"), a = n(25), o = n(27), i = n(18).f, c = 0, u = Object.isExtensible || function () {
				return !0
			}, s = !n(26)((function () {
				return u(Object.preventExtensions({}))
			})), f = function (e) {
				i(e, r, {value: {i: "O" + ++c, w: {}}})
			}, l = e.exports = {
				KEY: r, NEED: !1, fastKey: function (e, t) {
					if (!a(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;
					if (!o(e, r)) {
						if (!u(e)) return "F";
						if (!t) return "E";
						f(e)
					}
					return e[r].i
				}, getWeak: function (e, t) {
					if (!o(e, r)) {
						if (!u(e)) return !0;
						if (!t) return !1;
						f(e)
					}
					return e[r].w
				}, onFreeze: function (e) {
					return s && l.NEED && u(e) && !o(e, r) && f(e), e
				}
			}
		}, function (e, t, n) {
			var r = n(37), a = n(49), o = n(50);
			e.exports = function (e) {
				var t = r(e), n = a.f;
				if (n) for (var i, c = n(e), u = o.f, s = 0; c.length > s;) u.call(e, i = c[s++]) && t.push(i);
				return t
			}
		}, function (e, t, n) {
			var r = n(19), a = n(65).f, o = {}.toString,
				i = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
			e.exports.f = function (e) {
				return i && "[object Window]" == o.call(e) ? function (e) {
					try {
						return a(e)
					} catch (e) {
						return i.slice()
					}
				}(e) : a(r(e))
			}
		}, function (e, t, n) {
			n(64)("asyncIterator")
		}, function (e, t, n) {
			n(64)("observable")
		}, function (e, t, n) {
			n(33), n(151), e.exports = n(6).Array.from
		}, function (e, t, n) {
			"use strict";
			var r = n(35), a = n(10), o = n(39), i = n(86), c = n(87), u = n(56), s = n(97), f = n(61);
			a(a.S + a.F * !n(92)((function (e) {
				Array.from(e)
			})), "Array", {
				from: function (e) {
					var t, n, a, l, p = o(e), d = "function" == typeof this ? this : Array, h = arguments.length,
						m = h > 1 ? arguments[1] : void 0, v = void 0 !== m, g = 0, y = f(p);
					if (v && (m = r(m, h > 2 ? arguments[2] : void 0, 2)), null == y || d == Array && c(y)) for (n = new d(t = u(p.length)); t > g; g++) s(n, g, v ? m(p[g], g) : p[g]); else for (l = y.call(p), n = new d; !(a = l.next()).done; g++) s(n, g, v ? i(l, m, [a.value, g], !0) : a.value);
					return n.length = g, n
				}
			})
		}, function (e, t, n) {
			var r = n(13);
			e.exports = function (e) {
				if (r(e)) return e
			}
		}, function (e, t, n) {
			var r = n(67), a = n(98), o = n(41);
			e.exports = function (e, t) {
				if (void 0 !== o && a(Object(e))) {
					var n = [], i = !0, c = !1, u = void 0;
					try {
						for (var s, f = r(e); !(i = (s = f.next()).done) && (n.push(s.value), !t || n.length !== t); i = !0) ;
					} catch (e) {
						c = !0, u = e
					} finally {
						try {
							i || null == f.return || f.return()
						} finally {
							if (c) throw u
						}
					}
					return n
				}
			}
		}, function (e, t, n) {
			n(48), n(33), e.exports = n(155)
		}, function (e, t, n) {
			var r = n(60), a = n(11)("iterator"), o = n(30);
			e.exports = n(6).isIterable = function (e) {
				var t = Object(e);
				return void 0 !== t[a] || "@@iterator" in t || o.hasOwnProperty(r(t))
			}
		}, function (e, t) {
			e.exports = function () {
				throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
			}
		}, function (e, t, n) {
			n(158), e.exports = n(6).Date.now
		}, function (e, t, n) {
			var r = n(10);
			r(r.S, "Date", {
				now: function () {
					return (new Date).getTime()
				}
			})
		}, function (e, t, n) {
			var r = n(13), a = n(100);
			e.exports = function (e) {
				if (r(e)) return a(e)
			}
		}, function (e, t, n) {
			var r = n(51), a = n(98), o = n(41);
			e.exports = function (e) {
				if (void 0 !== o && a(Object(e))) return r(e)
			}
		}, function (e, t) {
			e.exports = function () {
				throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
			}
		}, function (e, t, n) {
			e.exports = n(163)
		}, function (e, t, n) {
			n(164), e.exports = n(6).Object.assign
		}, function (e, t, n) {
			var r = n(10);
			r(r.S + r.F, "Object", {assign: n(165)})
		}, function (e, t, n) {
			"use strict";
			var r = n(15), a = n(37), o = n(49), i = n(50), c = n(39), u = n(84), s = Object.assign;
			e.exports = !s || n(26)((function () {
				var e = {}, t = {}, n = Symbol(), r = "abcdefghijklmnopqrst";
				return e[n] = 7, r.split("").forEach((function (e) {
					t[e] = e
				})), 7 != s({}, e)[n] || Object.keys(s({}, t)).join("") != r
			})) ? function (e, t) {
				for (var n = c(e), s = arguments.length, f = 1, l = o.f, p = i.f; s > f;) for (var d, h = u(arguments[f++]), m = l ? a(h).concat(l(h)) : a(h), v = m.length, g = 0; v > g;) d = m[g++], r && !p.call(h, d) || (n[d] = h[d]);
				return n
			} : s
		}, function (e, t, n) {
			n(167);
			var r = n(6).Object;
			e.exports = function (e, t) {
				return r.defineProperties(e, t)
			}
		}, function (e, t, n) {
			var r = n(10);
			r(r.S + r.F * !n(15), "Object", {defineProperties: n(82)})
		}, function (e, t, n) {
			n(169);
			var r = n(6).Object;
			e.exports = function (e, t, n) {
				return r.defineProperty(e, t, n)
			}
		}, function (e, t, n) {
			var r = n(10);
			r(r.S + r.F * !n(15), "Object", {defineProperty: n(18).f})
		}, function (e, t, n) {
			n(171), e.exports = n(6).Object.getOwnPropertyDescriptors
		}, function (e, t, n) {
			var r = n(10), a = n(172), o = n(19), i = n(66), c = n(97);
			r(r.S, "Object", {
				getOwnPropertyDescriptors: function (e) {
					for (var t, n, r = o(e), u = i.f, s = a(r), f = {}, l = 0; s.length > l;) void 0 !== (n = u(r, t = s[l++])) && c(f, t, n);
					return f
				}
			})
		}, function (e, t, n) {
			var r = n(65), a = n(49), o = n(14), i = n(9).Reflect;
			e.exports = i && i.ownKeys || function (e) {
				var t = r.f(o(e)), n = a.f;
				return n ? t.concat(n(e)) : t
			}
		}, function (e, t, n) {
			n(174);
			var r = n(6).Object;
			e.exports = function (e, t) {
				return r.getOwnPropertyDescriptor(e, t)
			}
		}, function (e, t, n) {
			var r = n(19), a = n(66).f;
			n(95)("getOwnPropertyDescriptor", (function () {
				return function (e, t) {
					return a(r(e), t)
				}
			}))
		}, function (e, t, n) {
			n(96), e.exports = n(6).Object.getOwnPropertySymbols
		}, function (e, t, n) {
			n(177), e.exports = n(6).parseInt
		}, function (e, t, n) {
			var r = n(10), a = n(178);
			r(r.G + r.F * (parseInt != a), {parseInt: a})
		}, function (e, t, n) {
			var r = n(9).parseInt, a = n(179).trim, o = n(101), i = /^[-+]?0[xX]/;
			e.exports = 8 !== r(o + "08") || 22 !== r(o + "0x16") ? function (e, t) {
				var n = a(String(e), 3);
				return r(n, t >>> 0 || (i.test(n) ? 16 : 10))
			} : r
		}, function (e, t, n) {
			var r = n(10), a = n(44), o = n(26), i = n(101), c = "[" + i + "]", u = RegExp("^" + c + c + "*"),
				s = RegExp(c + c + "*$"), f = function (e, t, n) {
					var a = {}, c = o((function () {
						return !!i[e]() || "​" != "​"[e]()
					})), u = a[e] = c ? t(l) : i[e];
					n && (a[n] = u), r(r.P + r.F * c, "String", a)
				}, l = f.trim = function (e, t) {
					return e = String(a(e)), 1 & t && (e = e.replace(u, "")), 2 & t && (e = e.replace(s, "")), e
				};
			e.exports = f
		}, function (e, t, n) {
			"use strict";
			n.r(t);
			var r = n(1), a = n.n(r), o = n(3), i = n.n(o), c = n(2), u = n.n(c), s = n(0), f = n(32),
				l = function (e) {
					return function (t) {
						return new u.a((function (n, r) {
							e(t, n, r)
						}))
					}
				}, p = {};
			p.ready = l(function () {
				var e = i()(a.a.mark((function e(t, n, r) {
					return a.a.wrap((function (e) {
						for (; ;) switch (e.prev = e.next) {
							case 0:
								if ("function" == typeof t) {
									e.next = 3;
									break
								}
								return r({status: "0", msg: "Parameter is not a method"}), e.abrupt("return");
							case 3:
								"1" === s.e.status ? t() : Object(f.b)("__config_ready__", t), n();
							case 5:
							case"end":
								return e.stop()
						}
					}), e)
				})));
				return function (t, n, r) {
					return e.apply(this, arguments)
				}
			}()), p.error = l(function () {
				var e = i()(a.a.mark((function e(t, n, r) {
					return a.a.wrap((function (e) {
						for (; ;) switch (e.prev = e.next) {
							case 0:
								if ("function" == typeof t) {
									e.next = 3;
									break
								}
								return r({status: "0", msg: "Parameter is not a method"}), e.abrupt("return");
							case 3:
								"0" === s.e.status ? t(s.e) : Object(f.b)("__config_error__", t), n();
							case 5:
							case"end":
								return e.stop()
						}
					}), e)
				})));
				return function (t, n, r) {
					return e.apply(this, arguments)
				}
			}());
			t.default = function () {
				for (var e = [{apiName: "ready"}, {apiName: "error"}], t = 0; t < e.length; t += 1) {
					var n = e[t].apiName;
					HWH5[n] = p[n]
				}
			}
		}, function (e, t, n) {
			"use strict";
			n.r(t);
			var r, a, o = n(2), i = n.n(o), c = n(5), u = n.n(c), s = n(16), f = n.n(s), l = n(12), p = n.n(l),
				d = n(42),
				h = n.n(d), m = (a = (r = {}).hasOwnProperty, {
					subscribe: function (e, t) {
						a.call(r, e) || (r[e] = []);
						var n = r[e].push(t) - 1;
						return {
							remove: function () {
								delete r[e][n]
							}
						}
					}, publish: function (e, t) {
						a.call(r, e) && r[e].forEach((function (e) {
							e(void 0 !== t ? t : {})
						}))
					}
				}), v = n(43), g = n(21), y = n.n(g), b = n(105), w = n.n(b), x = n(17), k = n.n(x), N = n(1), _ = n.n(N),
				S = n(13), C = n.n(S), O = n(3), I = n.n(O), j = n(23), E = n.n(j), L = n(4), P = n.n(L), H = n(29),
				T = n(0), A = n(22), F = n(7), B = function (e) {
					return Object(H.a)((function (t) {
						var n = P()({funcName: e.funcName, data: e.data, callbackId: t});
						Object(T.s)("action", e.data, e.funcName, e.apiName, void 0, t), HWH5.callMethod(n)
					}), e)
				}, W = function (e) {
					var t = [], n = [].concat(E()(f.a), E()(p.a));
					return e.forEach((function (e) {
						var r = !1;
						n.forEach((function (n) {
							e === n.apiName && (t.push(n.nativeName ? n.nativeName : n.schema), r = !0)
						})), r || t.push(e)
					})), t
				}, D = function () {
					var e = I()(_.a.mark((function e(t) {
						var n, r;
						return _.a.wrap((function (e) {
							for (; ;) switch (e.prev = e.next) {
								case 0:
									return n = "", n = C()(t.filePath) ? t.filePath : [t.filePath], e.next = 4, HWH5.zipsFiles({
										filesPath: n,
										testCover: t.testCover
									}).then((function (e) {
										return e
									})).catch((function (e) {
										console.log("File packaging failed, ", e)
									}));
								case 4:
									if (!(r = e.sent) || !r.tempFilePath) {
										e.next = 7;
										break
									}
									return e.abrupt("return", r.tempFilePath);
								case 7:
									return e.abrupt("return", null);
								case 8:
								case"end":
									return e.stop()
							}
						}), e)
					})));
					return function (t) {
						return e.apply(this, arguments)
					}
				}(), M = function () {
					var e = I()(_.a.mark((function e(t) {
						var n;
						return _.a.wrap((function (e) {
							for (; ;) switch (e.prev = e.next) {
								case 0:
									return e.next = 2, HWH5.compressImage(t).then((function (e) {
										return e
									})).catch((function (e) {
										console.log("File compression failed, ", e)
									}));
								case 2:
									if (!(n = e.sent) || !n.tempFilePath) {
										e.next = 5;
										break
									}
									return e.abrupt("return", n.tempFilePath);
								case 5:
									return e.abrupt("return", null);
								case 6:
								case"end":
									return e.stop()
							}
						}), e)
					})));
					return function (t) {
						return e.apply(this, arguments)
					}
				}();
			function U(e) {
				return null !== e && "object" === k()(e)
			}
			var R = function () {
				var e = I()(_.a.mark((function e(t, n) {
					var r, a, o, i, c;
					return _.a.wrap((function (e) {
						for (; ;) switch (e.prev = e.next) {
							case 0:
								return e.next = 2, HWH5.getAuthCode({clientId: n});
							case 2:
								return r = e.sent, a = r.code, o = {
									appid: n,
									sso: "welink",
									token: a
								}, i = {"Content-Type": "application/json"}, e.prev = 6, e.next = 9, HWH5.fetchInternet("".concat(t, "/jwt/token"), {
									body: P()(o),
									headers: i,
									method: "post"
								}).then((function (e) {
									return e.json()
								}));
							case 9:
								if (!(c = e.sent)) {
									e.next = 13;
									break
								}
								return HWH5.setStorage({
									key: "welink_roma_auth_".concat(n),
									data: P()({time: (new Date).getTime(), jwt: c})
								}), e.abrupt("return", "".concat(c.token_type, " ").concat(c.access_token));
							case 13:
								return e.abrupt("return", null);
							case 16:
								return e.prev = 16, e.t0 = e.catch(6), e.abrupt("return", null);
							case 19:
							case"end":
								return e.stop()
						}
					}), e, null, [[6, 16]])
				})));
				return function (t, n) {
					return e.apply(this, arguments)
				}
			}(), J = function () {
				var e = I()(_.a.mark((function e(t) {
					var n, r, a, o;
					return _.a.wrap((function (e) {
						for (; ;) switch (e.prev = e.next) {
							case 0:
								return e.next = 2, HWH5.getStorage("welink_roma_auth_".concat(t));
							case 2:
								if (n = e.sent) {
									e.next = 5;
									break
								}
								return e.abrupt("return", null);
							case 5:
								if (r = n.jwt, a = n.time, r) {
									e.next = 9;
									break
								}
								return console.warn("Failed to get token"), e.abrupt("return", null);
							case 9:
								if (o = (new Date).getTime(), !(1e3 * w()(r.expire_in, 10) + a < o)) {
									e.next = 13;
									break
								}
								return e.abrupt("return", null);
							case 13:
								return e.abrupt("return", "".concat(r.token_type, " ").concat(r.access_token));
							case 14:
							case"end":
								return e.stop()
						}
					}), e)
				})));
				return function (t) {
					return e.apply(this, arguments)
				}
			}(), G = function () {
				var e = I()(_.a.mark((function e(t, n, r, a) {
					return _.a.wrap((function (e) {
						for (; ;) switch (e.prev = e.next) {
							case 0:
								HWH5[t] = function () {
									var e = I()(_.a.mark((function e(o, c) {
										var u, s, f, l, p, d, h, m, v, g, b, w, x, k, N, S, C, O, I;
										return _.a.wrap((function (e) {
											for (; ;) switch (e.prev = e.next) {
												case 0:
													if (Object(T.w)() && a && console.warn("“".concat(t, "” 暂不支持PC")), u = o, null !== r && (u = U(u) ? y()({}, r, u) : "string" == typeof u ? o : r), s = n, "fetch" !== t && "fetchInternet" !== t && "generateQRCode" !== t && "fetchIntranet" !== t && "fetchVPN" !== t || (u = {
														url: u,
														method: c && c.method || "get"
													}, "string" == typeof (u = y()(u, c)).method && (u.method = u.method.toLocaleLowerCase())), "fetchRomaApi" !== t) {
														e.next = 30;
														break
													}
													if ((l = (f = c).config) && l.baseUrl) {
														e.next = 11;
														break
													}
													return p = {
														code: "10802",
														message: "The parameter is incorrect. Please check the documentation",
														type: "error"
													}, e.abrupt("return", i.a.reject(p));
												case 11:
													return e.next = 13, Object(T.n)();
												case 13:
													return d = e.sent, h = d.appId, m = (m = h.endsWith(".dev.debug") ? h.replace(".dev.debug", "") : h).endsWith(".debug") ? m.replace(".debug", "") : m, e.next = 19, J(m);
												case 19:
													if (v = e.sent) {
														e.next = 24;
														break
													}
													return e.next = 23, R(l.baseUrl, m);
												case 23:
													v = e.sent;
												case 24:
													f.headers || (f.headers = {}), f.headers["X-HW-TOKEN"] = v, u = {
														url: u = u.startsWith("https://") || u.startsWith("http://") ? u : l.baseUrl + u,
														method: f && f.method || "get"
													}, "string" == typeof (u = y()(u, f)).method && (u.method = u.method.toLocaleLowerCase());
												case 30:
													if ("cache" === t && (s = u && u.key && void 0 !== u.data ? "setCache" : "getCache"), "setStorage" === t && (s = "setCache"), "getStorage" === t && (s = "getCache"), "showLoading" === t && (u = {status: !0}), "hideLoading" === t && (u = {status: !1}), "uploadImage" !== t || !u.filePath || !(u.maxWidth || u.maxHeight || u.maxSize)) {
														e.next = 39;
														break
													}
													return e.next = 38, M(u);
												case 38:
													u.filePath = e.sent;
												case 39:
													if ("uploadFile" !== t || !u.filePath || !u.zip) {
														e.next = 43;
														break
													}
													return e.next = 42, D(u);
												case 42:
													u.filePath = e.sent;
												case 43:
													if ("setNavigationBarButtons" === t && u.length > 0) for (HWH5.removeEventListenerByType && HWH5.removeEventListenerByType("navigationBarButtonClick"), g = 0; g < u.length; g += 1) void 0 !== HWH5.addEventListener && HWH5.addEventListener({
														type: "navigationBarButtonClick",
														func: u[g].func
													});
													if ("playMedia" !== t || !u || !u.backgroundAudioUrl) {
														e.next = 47;
														break
													}
													return "playMediaBackground", e.abrupt("return", B({
														funcName: "playMediaBackground",
														data: u,
														apiName: "playMediaBackground"
													}));
												case 47:
													if (("config" === t || "checkJsApi" === t) && u.jsApiList.length > 0 && ("config" === t && (delete T.e.status, delete T.e.errorCode, delete T.e.msg), u.apiNameList = u.jsApiList, u.jsApiList = W(u.jsApiList)), "enableFeedback" !== t) {
														e.next = 53;
														break
													}
													return e.next = 51, Object(T.n)();
												case 51:
													b = e.sent, u = {queryString: "module=wecode&wecodeId=".concat(b.appId)};
												case 53:
													if ("openBluetoothAdapter" === t && HWH5.onBluetoothEvents(), "writeBLECharacteristicValue" !== t && "writeDataToBluetooth" !== t || !u.value || (u.value = Object(T.a)(u.value)), "hwa" !== t) {
														e.next = 61;
														break
													}
													return e.next = 58, Object(T.n)();
												case 58:
													w = e.sent, x = w.appId, u && void 0 !== u.extendData && null !== u.extendData ? ((k = U(u.extendData) ? u.extendData : JSON.parse(u.extendData)).wecodeId = x, u.extendData = P()(k)) : u.extendData = P()({wecodeId: x});
												case 61:
													if ("playAudio" !== t && "playMedia" !== t || !u || "string" != typeof u.cookies || (u.cookies = Object(T.f)(u.cookies)), "config" === t && u && (F.c.appId = u.appId), "share" !== t) {
														e.next = 73;
														break
													}
													e.next = 72;
													break;
												case 67:
													N = e.sent, S = N.appId, u.data.appid = S, e.next = 73;
													break;
												case 72:
													u.data.appid = F.c.appId;
												case 73:
													if (["getClouddriveFilesList", "uploadClouddriveFile", "downloadClouddriveFile"].indexOf(t) > -1 && ("WeCode", u.packageName = u.packageName ? u.packageName : "WeCode"), "setNavigationBarType" === t && (u = {navigationBarType: u}), "setNavigationBar" === t && (u = {navigationBar: u}), "navigateToPage" !== t && "navigateToWecode" !== t || !u || !u.uri) {
														e.next = 80;
														break
													}
													if (!("string" == typeof u.uri && u.uri.indexOf("wecodeDefine1") > -1)) {
														e.next = 80;
														break
													}
													return C = {
														code: "30803",
														message: "The URI contains invalid keywords.",
														type: "error"
													}, e.abrupt("return", i.a.reject(C));
												case 80:
													if (!(A.b.getState() || F.f[t] && F.f[t].j_p_c) || Object(A.a)(t, u)) {
														e.next = 83;
														break
													}
													return O = {
														code: "10802",
														message: "The parameter is incorrect. Please check the documentation",
														type: "error"
													}, e.abrupt("return", i.a.reject(O));
												case 83:
													if (!Object(T.u)() || "checkSkyStoneStatus" !== t) {
														e.next = 86;
														break
													}
													return I = {
														status: 0,
														statusCode: "0"
													}, e.abrupt("return", i.a.resolve(I));
												case 86:
													return e.abrupt("return", B({funcName: s, data: u, apiName: t}));
												case 87:
												case"end":
													return e.stop()
											}
										}), e)
									})));
									return function (t, n) {
										return e.apply(this, arguments)
									}
								}();
							case 1:
							case"end":
								return e.stop()
						}
					}), e)
				})));
				return function (t, n, r, a) {
					return e.apply(this, arguments)
				}
			}(), V = function () {
				var e = f.a;
				e = n(93);
				for (var t = 0; t < e.length; t += 1) {
					var r = e[t], a = r.apiName, o = r.nativeName, i = r.defaultParams, c = void 0 === i ? null : i,
						u = r.pcNotSupport;
					G(a, o, c, u)
				}
			}, z = n(106);
			function q() {
				return new i.a(function () {
					var e = I()(_.a.mark((function e(t) {
						var n;
						return _.a.wrap((function (e) {
							for (; ;) switch (e.prev = e.next) {
								case 0:
									if (n = null, !u.a.HWH5 || "function" != typeof u.a.HWH5.hwa) {
										e.next = 12;
										break
									}
									return e.t0 = u.a.HWH5, e.t1 = P.a, e.next = 6, new i.a(function () {
										var e = I()(_.a.mark((function e(t) {
											var n, r;
											return _.a.wrap((function (e) {
												for (; ;) switch (e.prev = e.next) {
													case 0:
														return n = u.a.performance.timing, e.next = 3, Object(T.n)();
													case 3:
														r = e.sent, t({
															uri: u.a.location.toString(),
															domInteractive: n.domInteractive - n.navigationStart,
															domContentLoaded: n.domContentLoadedEventEnd - n.navigationStart,
															domLoad: n.loadEventEnd - n.navigationStart,
															appId: r.appId
														});
													case 5:
													case"end":
														return e.stop()
												}
											}), e)
										})));
										return function (t) {
											return e.apply(this, arguments)
										}
									}()).then((function (e) {
										return e
									}));
								case 6:
									e.t2 = e.sent, e.t3 = (0, e.t1)(e.t2), e.t4 = {
										eventId: "WELINK_WECODE_PERFORMANCE",
										eventLabel: "WeLink WECODE PERFORMANCE",
										extendData: e.t3,
										common_internal_call: !0
									}, n = e.t0.hwa.call(e.t0, e.t4), e.next = 13;
									break;
								case 12:
									n = null;
								case 13:
									t(n);
								case 14:
								case"end":
									return e.stop()
							}
						}), e)
					})));
					return function (t) {
						return e.apply(this, arguments)
					}
				}())
			}
			function K() {
				return (K = I()(_.a.mark((function e() {
					return _.a.wrap((function (e) {
						for (; ;) switch (e.prev = e.next) {
							case 0:
								if (u.a.performance) {
									e.next = 2;
									break
								}
								return e.abrupt("return");
							case 2:
								if (!(u.a.performance.timing && u.a.performance.timing.loadEventEnd > 0)) {
									e.next = 5;
									break
								}
								return e.next = 5, q();
							case 5:
								u.a.addEventListener("load", I()(_.a.mark((function e() {
									return _.a.wrap((function (e) {
										for (; ;) switch (e.prev = e.next) {
											case 0:
												return e.t0 = setTimeout, e.next = 3, q;
											case 3:
												e.t1 = e.sent, (0, e.t0)(e.t1, 0);
											case 5:
											case"end":
												return e.stop()
										}
									}), e)
								}))));
							case 6:
							case"end":
								return e.stop()
						}
					}), e)
				})))).apply(this, arguments)
			}
			n(31);
			var Q = function (e, t) {
				for (var n = t, r = function (t) {
					var r = e[t].apiName;
					n[r] = function () {
						for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
						return new i.a((function (e, n) {
							var a = m.subscribe("hwh5ready", (function () {
								HWH5[r].apply(u.a, t).then((function (t) {
									e(t)
								})).catch((function (e) {
									n(e)
								})), a.remove()
							}))
						}))
					}
				}, a = 0; a < e.length; a += 1) r(a);
				return n
			}, $ = function () {
				Object(z.a)(), (0, n(180).default)(), Object(v.c)(), V(), function () {
					K.apply(this, arguments)
				}(), u.a.HWH5.callbackNative = H.b
			};
			(function () {
				Object(T.u)() && u.a.webkit && u.a.webkit.messageHandlers ? (u.a.HWH5 = {
					callMethod: function (e) {
						u.a.webkit.messageHandlers.HWH5.postMessage({callMethod: e})
					}, openURI: function (e) {
						u.a.webkit.messageHandlers.HWH5.postMessage({openURI: e})
					}
				}, $()) : "undefined" != typeof HWH5 && HWH5.callMethod ? $() : (u.a.HWH5 = {}, u.a.HWH5 = Q(f.a, u.a.HWH5), u.a.HWH5 = Q(p.a, u.a.HWH5), u.a.HWH5 = Q(h.a, u.a.HWH5), u.a._HWH5Init = function () {
					$(), m.publish("hwh5ready")
				}), Object(T.q)()
			})();
			t.default = HWH5
		}])
	}))
}
/**
 * @description 去单点服务器登录
 */
export const toLogin = () => {
	// 删除Token
	// removeToken()
	// 判断是否在钉钉中
	if (isDingtalk() && __APP_ENV__.VUE_APP_SSO_CORP_ID) {
		dd.ready(() => {
			dd.runtime.permission.requestAuthCode({
				corpId: __APP_ENV__.VUE_APP_SSO_CORP_ID, // 企业id
				onSuccess: (info) => {
					if (__APP_ENV__.VUE_APP_SSO_ALERT) {
						alert(info.code)
					}
					// 通过该免登授权码可以获取用户身份
					window.location.href = ssoUrl() + '&code=' + info.code + '&device=1'
				}
			});
		});
	} else if (isWelink()) {
		HWH5.getAuthCode().then(data => {
			// 通过该免登授权码可以获取用户身份
			window.location.href = ssoUrl() + '&code=' + data.code + '&device=2'
		}).catch(error => {
			console.log('获取异常', error);
		});
	} else {
		window.location.href = ssoUrl()
	}
}
/**
 * @description 去单点服务器登出
 */
export const toLogout = token => {
	// 删除Token
	removeToken()
	// 回到单点
	window.location.href = ssoUrl() + '&session_id=' + token
}
/**
 * @description 去单点服务器地址
 */
export const ssoUrl = url => {
	let pageUrl = window.location.pathname + window.location.search;
	console.info("pageUrl:" + pageUrl)
	if (pageUrl.indexOf('codeCallback') != -1) {
		pageUrl = __APP_ENV__.VITE_APP_PORTAL_HOST_URL
	} else {
		pageUrl = encodeURIComponent(pageUrl)
	}
	console.info("pageUrl:" + pageUrl)
	const portalUrl = __APP_ENV__.VITE_APP_PORTAL_HOST_URL || pageUrl;
	const ssoHostUrl = __APP_ENV__.VITE_APP_SSO_HOST_URL;
	const callbackUrl = __APP_ENV__.VUE_APP_SSO_CALLBACK_URL || 'codeCallback';
	const responseType = __APP_ENV__.VITE_APP_SSO_RESPONSE_TYPE || 'code';
	const clientId = __APP_ENV__.VITE_APP_SSO_APP_KEY || 'chaos-test';
	const contextPath = __APP_ENV__.VITE_APP_PORTAL_HOST_CONTEXT_PATH || '/';
	let redirectUri = pageUrl;
	if (contextPath != '/') {
		redirectUri = pageUrl.replace(encodeURIComponent(contextPath), encodeURIComponent('/'))
	}
	let codeCallbackUrl = encodeURIComponent(`${portalUrl}${callbackUrl}?redirect_uri=${redirectUri}`);
	console.info("codeCallbackUrl:" + codeCallbackUrl)
	let api = 'oauth'
	if (isDingtalk() && __APP_ENV__.VITE_APP_SSO_CORP_ID) {
		api = 'app'
	}
	if (isWelink()) {
		api = 'app'
	}
	let ssoUrl = `${ssoHostUrl}${api}/authorize`
	let params = `?response_type=${responseType}&client_id=${clientId}&redirect_uri=${codeCallbackUrl}`
	let finalUrl = ssoUrl + params;
	console.info("finalUrl:" + finalUrl)
	return finalUrl
}
export const setToken = token => {
	window.localStorage.setItem(__APP_ENV__.VITE_APP_SSO_SESSION_TOKEN_KEY || 'sso-token', token)
}
export const getToken = () => {
	const token = window.localStorage.getItem(__APP_ENV__.VITE_APP_SSO_SESSION_TOKEN_KEY || 'sso-token')
	if (token) {
		return token
	}
	return false
}
export const removeToken = () => {
	window.localStorage.removeItem(__APP_ENV__.VITE_APP_SSO_SESSION_TOKEN_KEY || 'sso-token')
}
export const setUser = user => {
	window.localStorage.setItem(__APP_ENV__.VITE_APP_SSO_SESSION_USER_KEY || 'sso-user', JSON.stringify(user))
}
export const getUser = () => {
	const user = window.localStorage.getItem(__APP_ENV__.VITE_APP_SSO_SESSION_USER_KEY || 'sso-user')
	if (user) return JSON.parse(user)
	else return false
}
export const removeUser = () => {
	window.localStorage.removeItem(__APP_ENV__.VITE_APP_SSO_SESSION_USER_KEY || 'sso-user')
}
export const remove = () => {
	removeUser()
	removeToken()
}
